"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.f116 = void 0;
exports.f116 = {
    "təsu": [
        9
    ],
    "tarbrisht": [
        12,
        13
    ],
    "tamanghasset arabic": [
        21
    ],
    "tamanghasset": [
        21
    ],
    "tamanrasset arabic": [
        21
    ],
    "tamanrasset": [
        21
    ],
    "tz": [
        24,
        460,
        700,
        703,
        740,
        1019,
        1378,
        1703,
        1705,
        1840,
        1916,
        1933,
        2216,
        2389,
        2700,
        2730,
        2749,
        2845,
        2898,
        2901,
        2909,
        2925,
        2956,
        3067,
        3191,
        3238,
        3255,
        3374,
        3391,
        3526,
        3531,
        3533,
        3535,
        3561,
        3689,
        3693,
        3744,
        3905,
        3955,
        4023,
        4132,
        4195,
        4592,
        4757,
        4759,
        4762,
        4763,
        4764,
        4765,
        4770,
        4823,
        4984,
        5171,
        5178,
        5202,
        5203,
        5364,
        5365,
        5367,
        5434,
        5435,
        5474,
        5479,
        5495,
        5530,
        5609,
        5638,
        5687,
        5715,
        5775,
        5799,
        5811,
        5892,
        6055,
        6162,
        6267,
        6495,
        6524,
        6574,
        6585,
        6621,
        6624,
        6638,
        6639,
        6661,
        6701,
        6703,
        6706,
        6780,
        7048,
        7130,
        7193,
        7194,
        7205,
        7223,
        7224,
        7234,
        7235,
        7357,
        7636,
        7879,
        8082,
        8086,
        8144,
        8179,
        8180,
        8181,
        8246,
        8366,
        8561,
        8979,
        8980,
        9012,
        9056,
        9057
    ],
    "tanzania": [
        5474,
        5530,
        460,
        740,
        3526,
        4529,
        4759,
        6495,
        6706,
        7879,
        8561,
        24,
        700,
        703,
        1019,
        1378,
        1703,
        1705,
        1840,
        1916,
        1933,
        2216,
        2389,
        2700,
        2730,
        2749,
        2845,
        2898,
        2901,
        2909,
        2925,
        2956,
        3067,
        3191,
        3238,
        3255,
        3374,
        3391,
        3531,
        3533,
        3535,
        3561,
        3689,
        3693,
        3744,
        3905,
        3955,
        4023,
        4132,
        4195,
        4592,
        4757,
        4762,
        4763,
        4764,
        4765,
        4770,
        4823,
        4984,
        5171,
        5178,
        5202,
        5203,
        5364,
        5365,
        5367,
        5434,
        5435,
        5479,
        5495,
        5609,
        5638,
        5687,
        5715,
        5775,
        5799,
        5811,
        5892,
        6055,
        6162,
        6267,
        6524,
        6574,
        6585,
        6621,
        6624,
        6638,
        6639,
        6661,
        6701,
        6703,
        6780,
        7048,
        7130,
        7193,
        7194,
        7205,
        7223,
        7224,
        7234,
        7235,
        7357,
        7636,
        8082,
        8086,
        8144,
        8179,
        8180,
        8181,
        8246,
        8366,
        8979,
        8980,
        9012,
        9056,
        9057
    ],
    "timor amarasi": [
        29
    ],
    "timor": [
        7817,
        29,
        366
    ],
    "tajiki": [
        39,
        7108,
        7442,
        7443,
        7444,
        7445
    ],
    "tajiki arabic": [
        39
    ],
    "tj": [
        39,
        6034,
        6813,
        6814,
        7442,
        7445,
        8185,
        8724,
        8725,
        8726
    ],
    "tajikistan": [
        39,
        6034,
        6813,
        6814,
        7442,
        7445,
        8185,
        8724,
        8725,
        8726
    ],
    "tr": [
        48,
        110,
        801,
        802,
        2952,
        2969,
        3053,
        3069,
        3212,
        3688,
        3733,
        4007,
        4009,
        4131,
        4190,
        4191,
        4568,
        5397,
        5854,
        5980,
        6195,
        6243,
        7098,
        7268,
        7694,
        7695,
        7696,
        7699,
        7720,
        7721,
        7741,
        7903,
        7904,
        8437,
        8479,
        8519,
        8520,
        8593,
        8605,
        8613,
        8630,
        8682,
        8855,
        9063,
        9156,
        9186,
        9187
    ],
    "turkey": [
        48,
        110,
        801,
        802,
        2952,
        2969,
        3053,
        3069,
        3212,
        3688,
        3733,
        4007,
        4009,
        4131,
        4190,
        4191,
        4568,
        5397,
        5854,
        5980,
        6195,
        6243,
        7098,
        7268,
        7694,
        7695,
        7696,
        7699,
        7720,
        7721,
        7741,
        7903,
        7904,
        8437,
        8479,
        8519,
        8520,
        8593,
        8605,
        8613,
        8630,
        8682,
        8855,
        9063,
        9156,
        9186,
        9187
    ],
    "tai sa’": [
        71
    ],
    "tai": [
        933,
        934,
        935,
        1694,
        7386,
        7387,
        7474,
        7519,
        7524,
        7577,
        7601,
        7632,
        7672,
        7825,
        7826,
        7865,
        7866,
        7870,
        71,
        189,
        210,
        789,
        3372,
        3645,
        3646,
        3663,
        3743,
        3974,
        4147,
        4220,
        4235,
        5620,
        5621,
        5676,
        5745,
        6125,
        6486,
        6845,
        6846,
        6847,
        6848,
        6913,
        7023,
        7024,
        7322,
        7546,
        7725,
        7871,
        7878,
        7894,
        4439,
        7043
    ],
    "ta’izzi-adeni": [
        73
    ],
    "ta'izzi-adeni arabic": [
        73
    ],
    "taizzi-adeni": [
        73
    ],
    "tl": [
        88,
        756,
        908,
        1774,
        2521,
        2915,
        3142,
        3570,
        3930,
        4357,
        4544,
        4752,
        4818,
        4871,
        5771,
        6340,
        7403,
        7427,
        7538,
        7817,
        8258,
        8277
    ],
    "timor-leste": [
        88,
        756,
        908,
        1774,
        2521,
        2915,
        3142,
        3570,
        3930,
        4357,
        4544,
        4752,
        4818,
        4871,
        5771,
        6340,
        7403,
        7427,
        7538,
        7817,
        8258,
        8277
    ],
    "tg": [
        90,
        186,
        249,
        369,
        578,
        1056,
        1173,
        1174,
        2062,
        2461,
        2605,
        2709,
        3147,
        3492,
        3493,
        3538,
        3539,
        3563,
        3578,
        3888,
        4210,
        4726,
        5589,
        8195,
        8362,
        9077
    ],
    "togo": [
        463,
        464,
        1985,
        4210,
        90,
        186,
        249,
        369,
        578,
        1056,
        1173,
        1174,
        2062,
        2461,
        2605,
        2709,
        3147,
        3492,
        3493,
        3538,
        3539,
        3563,
        3578,
        3888,
        4726,
        5589,
        8195,
        8362,
        9077
    ],
    "tadon": [
        101,
        3192
    ],
    "tibetan, amdo": [
        107
    ],
    "tibetan": [
        107,
        997,
        998,
        999,
        1000,
        1001,
        3651,
        4498,
        5981,
        8438,
        1957,
        3089
    ],
    "tunisian": [
        7733,
        116,
        117,
        3330
    ],
    "tunisian arabic": [
        116,
        117
    ],
    "tunisian darija": [
        116,
        117
    ],
    "tn": [
        116,
        117,
        225,
        433,
        2462,
        6212,
        6765,
        7733
    ],
    "tunisia": [
        116,
        117,
        225,
        433,
        2462,
        6212,
        6765,
        7733
    ],
    "tapei": [
        145
    ],
    "the democratic republic of the congo": [
        157,
        281,
        480,
        638,
        646,
        674,
        679,
        834,
        849,
        858,
        859,
        889,
        899,
        903,
        919,
        945,
        950,
        955,
        980,
        994,
        1007,
        1033,
        1070,
        1083,
        1091,
        1176,
        1190,
        1233,
        1241,
        1244,
        1254,
        1279,
        1309,
        1311,
        1812,
        1867,
        1923,
        1942,
        2049,
        2065,
        2401,
        2412,
        2426,
        2496,
        2613,
        2656,
        2750,
        2906,
        2911,
        2927,
        2957,
        3031,
        3083,
        3355,
        3410,
        3486,
        3527,
        3528,
        3537,
        3569,
        3620,
        3667,
        3668,
        3753,
        3814,
        3845,
        3885,
        3975,
        3987,
        4001,
        4005,
        4090,
        4096,
        4183,
        4204,
        4266,
        4269,
        4274,
        4276,
        4284,
        4306,
        4312,
        4328,
        4334,
        4348,
        4401,
        4419,
        4438,
        4445,
        4450,
        4454,
        4456,
        4492,
        4517,
        4518,
        4524,
        4548,
        4660,
        4661,
        4662,
        4664,
        4666,
        4667,
        4710,
        4925,
        4942,
        5082,
        5204,
        5212,
        5234,
        5313,
        5331,
        5368,
        5369,
        5377,
        5380,
        5421,
        5422,
        5423,
        5490,
        5491,
        5533,
        5549,
        5553,
        5592,
        5633,
        5717,
        5728,
        5746,
        5772,
        5789,
        5793,
        5796,
        5814,
        5873,
        5908,
        5910,
        6021,
        6100,
        6204,
        6252,
        6275,
        6568,
        6832,
        6852,
        6932,
        6959,
        6986,
        6995,
        6996,
        7026,
        7027,
        7028,
        7038,
        7039,
        7188,
        7225,
        7230,
        7231,
        7232,
        7287,
        7315,
        7341,
        7347,
        7418,
        7503,
        7572,
        7609,
        7652,
        8061,
        8316,
        8722,
        8774,
        8843,
        8861,
        8867,
        8878,
        9074,
        9082,
        9086,
        9096,
        9097,
        9099,
        9103,
        9106,
        9108
    ],
    "the": [
        1969,
        6007,
        7164,
        2997,
        2998,
        9184,
        157,
        281,
        480,
        638,
        646,
        674,
        679,
        834,
        849,
        858,
        859,
        889,
        899,
        903,
        919,
        945,
        950,
        955,
        980,
        994,
        1007,
        1033,
        1070,
        1083,
        1091,
        1176,
        1190,
        1233,
        1241,
        1244,
        1254,
        1279,
        1309,
        1311,
        1812,
        1867,
        1923,
        1942,
        2049,
        2065,
        2401,
        2412,
        2426,
        2496,
        2613,
        2656,
        2750,
        2906,
        2911,
        2927,
        2957,
        3031,
        3083,
        3355,
        3410,
        3486,
        3527,
        3528,
        3537,
        3569,
        3620,
        3667,
        3668,
        3753,
        3814,
        3845,
        3885,
        3975,
        3987,
        4001,
        4005,
        4090,
        4096,
        4183,
        4204,
        4266,
        4269,
        4274,
        4276,
        4284,
        4306,
        4312,
        4328,
        4334,
        4348,
        4401,
        4419,
        4438,
        4445,
        4450,
        4454,
        4456,
        4492,
        4517,
        4518,
        4524,
        4548,
        4660,
        4661,
        4662,
        4664,
        4666,
        4667,
        4710,
        4925,
        4942,
        5082,
        5204,
        5212,
        5234,
        5313,
        5331,
        5368,
        5369,
        5377,
        5380,
        5421,
        5422,
        5423,
        5490,
        5491,
        5533,
        5549,
        5553,
        5592,
        5633,
        5717,
        5728,
        5746,
        5772,
        5789,
        5793,
        5796,
        5814,
        5873,
        5908,
        5910,
        6021,
        6100,
        6204,
        6252,
        6275,
        6568,
        6832,
        6852,
        6932,
        6959,
        6986,
        6995,
        6996,
        7026,
        7027,
        7028,
        7038,
        7039,
        7188,
        7225,
        7230,
        7231,
        7232,
        7287,
        7315,
        7341,
        7347,
        7418,
        7503,
        7572,
        7609,
        7652,
        8061,
        8316,
        8722,
        8774,
        8843,
        8861,
        8867,
        8878,
        9074,
        9082,
        9086,
        9096,
        9097,
        9099,
        9103,
        9106,
        9108,
        1599,
        2219,
        2257,
        7217
    ],
    "tainae": [
        165
    ],
    "tagalog": [
        7556,
        7557,
        7558,
        7559,
        171
    ],
    "tiagbamrin": [
        180
    ],
    "tiagba": [
        180
    ],
    "tiagbamrin aizi": [
        180
    ],
    "th": [
        184,
        185,
        753,
        931,
        1104,
        1105,
        1106,
        1305,
        1361,
        1566,
        1632,
        3009,
        3286,
        3550,
        3704,
        3718,
        3722,
        3839,
        4111,
        4112,
        4552,
        4707,
        4708,
        4858,
        5009,
        5028,
        5039,
        5194,
        5201,
        5620,
        5621,
        5798,
        5809,
        6066,
        6132,
        6133,
        6135,
        6283,
        6300,
        6382,
        6848,
        6913,
        7023,
        7024,
        7043,
        7148,
        7468,
        7469,
        7477,
        7637,
        7743,
        7772,
        7924,
        8000,
        8865,
        8882,
        9039
    ],
    "thailand": [
        3718,
        4111,
        4112,
        3713,
        3714,
        3715,
        3716,
        3717,
        184,
        185,
        753,
        931,
        1104,
        1105,
        1106,
        1305,
        1361,
        1566,
        1632,
        3009,
        3286,
        3550,
        3704,
        3722,
        3839,
        4552,
        4707,
        4708,
        4858,
        5009,
        5028,
        5039,
        5194,
        5201,
        5620,
        5621,
        5798,
        5809,
        6066,
        6132,
        6133,
        6135,
        6283,
        6300,
        6382,
        6848,
        6913,
        7023,
        7024,
        7043,
        7148,
        7468,
        7469,
        7477,
        7637,
        7743,
        7772,
        7924,
        8000,
        8865,
        8882,
        9039
    ],
    "tai ahom": [
        189
    ],
    "tai aiton": [
        210
    ],
    "triometesem": [
        245
    ],
    "triometesen": [
        245
    ],
    "tchamba": [
        249,
        1375
    ],
    "tunnu": [
        260,
        261
    ],
    "turiwa": [
        285
    ],
    "timap": [
        286,
        299
    ],
    "tanah": [
        292,
        4352,
        7624,
        6222
    ],
    "tw": [
        292,
        293,
        985,
        1288,
        1303,
        1510,
        1966,
        2415,
        3463,
        5294,
        5295,
        5296,
        5297,
        6279,
        6379,
        6388,
        6389,
        7134,
        7262,
        7295,
        7314,
        7324,
        7325,
        7326,
        7722,
        7745,
        7747,
        7816,
        8030,
        8557,
        8644,
        9020,
        9026,
        9040
    ],
    "td": [
        294,
        432,
        659,
        697,
        699,
        732,
        839,
        881,
        952,
        1130,
        1149,
        1171,
        1196,
        1201,
        1210,
        1268,
        1402,
        1505,
        1722,
        1729,
        1742,
        1870,
        1971,
        2047,
        2380,
        2407,
        2460,
        2489,
        2509,
        2585,
        2588,
        2676,
        2679,
        2685,
        2751,
        2759,
        2832,
        2923,
        3033,
        3354,
        3451,
        3488,
        3575,
        3671,
        3675,
        3746,
        3769,
        3868,
        3913,
        3989,
        4050,
        4053,
        4079,
        4093,
        4109,
        4148,
        4207,
        4387,
        4397,
        4638,
        4647,
        4655,
        4656,
        4658,
        4699,
        4740,
        4744,
        4821,
        4883,
        4924,
        4939,
        4977,
        4983,
        4990,
        4994,
        5077,
        5127,
        5134,
        5158,
        5169,
        5185,
        5233,
        5370,
        5383,
        5471,
        5563,
        5593,
        5605,
        5639,
        5820,
        6594,
        6658,
        6691,
        6700,
        6855,
        6856,
        6893,
        7036,
        7041,
        7252,
        7278,
        7323,
        7587,
        7589,
        7619,
        7709,
        7789,
        7797,
        7897,
        8091,
        8680,
        9055,
        9107,
        9151
    ],
    "takamanda": [
        339
    ],
    "tome": [
        344,
        1607,
        6286,
        6339
    ],
    "taulipáng": [
        346
    ],
    "taurepáng": [
        346
    ],
    "tjimundo": [
        350
    ],
    "taikat": [
        361
    ],
    "tajkat": [
        361
    ],
    "timol": [
        366
    ],
    "timoreesch": [
        366
    ],
    "timoreezen": [
        366
    ],
    "timorese": [
        366
    ],
    "timbira ocidentais": [
        382
    ],
    "timbira": [
        382
    ],
    "tolokiwa": [
        386
    ],
    "tutunohan": [
        392,
        7887,
        8213
    ],
    "tapueyocaca": [
        445
    ],
    "tapueyocuaca": [
        445
    ],
    "tupi": [
        6022,
        8240,
        450,
        3426,
        8896
    ],
    "togo sign language": [
        463,
        464
    ],
    "tsishingini": [
        7749,
        466
    ],
    "tekiraka": [
        467
    ],
    "tequiraca": [
        467
    ],
    "tocantins": [
        479,
        4679
    ],
    "trocará": [
        479
    ],
    "tocantins asurini": [
        479
    ],
    "tsaiva": [
        486,
        487
    ],
    "tsaiwa": [
        486,
        487
    ],
    "tête de boule": [
        493
    ],
    "tête": [
        493
    ],
    "thok cieng reel": [
        504
    ],
    "thok": [
        5743,
        5744,
        504
    ],
    "thok reel": [
        504
    ],
    "thuɔk ë rëël": [
        504
    ],
    "thuɔk": [
        504
    ],
    "telengit": [
        505
    ],
    "telengut": [
        505
    ],
    "teleut": [
        505
    ],
    "tededö": [
        512
    ],
    "terero": [
        512
    ],
    "tiriro": [
        512
    ],
    "te taranga pakaanuta": [
        513
    ],
    "te": [
        4790,
        513,
        4955,
        6175,
        6472,
        6934,
        7808,
        4235
    ],
    "taranga": [
        513
    ],
    "te taranga paka-anuta": [
        513
    ],
    "tirio": [
        523
    ],
    "tuhaa": [
        526
    ],
    "tubuai-rurutu": [
        526
    ],
    "tocipu": [
        548
    ],
    "taupi": [
        554
    ],
    "thio": [
        571
    ],
    "takrat": [
        584
    ],
    "totobiegosode": [
        584
    ],
    "tayabas ayta": [
        590
    ],
    "tayabas": [
        590
    ],
    "turk": [
        599,
        600,
        601,
        592,
        593,
        596,
        597,
        3195
    ],
    "turkler": [
        592,
        593,
        596,
        597
    ],
    "turkmen": [
        7532,
        7533,
        7534,
        7535,
        599,
        600,
        601
    ],
    "turkomen": [
        599,
        600,
        601
    ],
    "türki": [
        599,
        600,
        601
    ],
    "ts’unuma": [
        604
    ],
    "tuki": [
        615
    ],
    "tukí": [
        615
    ],
    "tupen": [
        626
    ],
    "toba": [
        7639,
        635,
        636,
        7592
    ],
    "toba batak": [
        635,
        636
    ],
    "tsova-tush": [
        645
    ],
    "tush": [
        645
    ],
    "tsunari": [
        671
    ],
    "tara baaka": [
        692
    ],
    "tara": [
        692,
        6228
    ],
    "tara baka": [
        692
    ],
    "taurije’ne’": [
        696
    ],
    "tar murba": [
        699
    ],
    "tar": [
        699,
        952,
        3518
    ],
    "tangkou": [
        708
    ],
    "to budo-budo": [
        708
    ],
    "to": [
        7659,
        5824,
        6295,
        6805,
        6806,
        708,
        724,
        725,
        1057,
        1177,
        1178,
        6317,
        1529,
        2764,
        2765,
        2766,
        4235,
        2213,
        5526,
        5736,
        7638
    ],
    "tongkou": [
        708
    ],
    "tau’ kitah": [
        721
    ],
    "tau’": [
        721
    ],
    "tibďaːwyě": [
        724,
        725
    ],
    "to bedawiat": [
        724,
        725
    ],
    "to bedawie": [
        724,
        725
    ],
    "tu bdhaawi": [
        724,
        725
    ],
    "tu": [
        4822,
        724,
        725,
        2893,
        2894,
        2895,
        8898,
        9044,
        9045,
        1417,
        6936
    ],
    "tu-bedawie": [
        724,
        725
    ],
    "tubdhaawi": [
        724,
        725
    ],
    "tarang": [
        734
    ],
    "tena": [
        6412,
        746,
        4582,
        4583,
        4584
    ],
    "ten’a": [
        746,
        3871
    ],
    "tonda": [
        749
    ],
    "tai bo": [
        789
    ],
    "thay bo": [
        789
    ],
    "thay": [
        789
    ],
    "tm": [
        791,
        1442,
        7532,
        7535
    ],
    "turkmenistan": [
        791,
        1442,
        7532,
        7535
    ],
    "tagabawa": [
        796
    ],
    "tagabawa bagobo": [
        796
    ],
    "tagabawa manobo": [
        796
    ],
    "turkish": [
        7694,
        7695,
        7696,
        7697,
        7698,
        7699,
        7741,
        801,
        802,
        3817,
        5980,
        5985,
        1604,
        1605,
        1606,
        3337,
        3338,
        7182
    ],
    "turkic": [
        3548,
        3549,
        3773,
        801,
        802,
        3817
    ],
    "türkçesi": [
        801,
        802,
        1604,
        1605,
        1606
    ],
    "tukang besi south": [
        825
    ],
    "tukang": [
        825,
        3647
    ],
    "tukang-besi": [
        825
    ],
    "tobada’": [
        835
    ],
    "tangga": [
        875,
        3046,
        3055
    ],
    "tinggian": [
        3268,
        3279,
        883
    ],
    "timggian": [
        883
    ],
    "tinguian": [
        883,
        3265,
        3268,
        3279,
        7514
    ],
    "talaandig": [
        888
    ],
    "teteris": [
        895
    ],
    "tor": [
        895,
        4077
    ],
    "tamboeko": [
        910
    ],
    "tambuku": [
        910
    ],
    "tobuco": [
        910
    ],
    "taungthu": [
        921
    ],
    "taungtu": [
        921
    ],
    "tai dam": [
        933,
        934,
        935
    ],
    "tai do": [
        933,
        934,
        935,
        7865,
        7866
    ],
    "tai noir": [
        933,
        934,
        935
    ],
    "tailam": [
        933,
        934,
        935
    ],
    "tailon": [
        933,
        934,
        935
    ],
    "thai den": [
        933,
        934,
        935
    ],
    "thai": [
        5620,
        5621,
        7023,
        7024,
        7043,
        7468,
        7469,
        7743,
        7772,
        6132,
        933,
        934,
        935,
        3645,
        3646,
        7672,
        7865,
        7866,
        4439,
        6845,
        6846,
        6847,
        6848,
        7870,
        9188
    ],
    "thái den": [
        933,
        934,
        935
    ],
    "thái": [
        933,
        934,
        935,
        7825,
        7826
    ],
    "tar bagrimma": [
        952
    ],
    "tar barma": [
        952
    ],
    "tshirambo": [
        958
    ],
    "tawbuid": [
        7819,
        981
    ],
    "tabuid": [
        981
    ],
    "taubuid": [
        981,
        7819
    ],
    "tiron": [
        981
    ],
    "talasea": [
        987
    ],
    "tibetan, central": [
        997,
        999,
        1000,
        1001
    ],
    "tebilian": [
        997,
        1000,
        1001
    ],
    "tibate": [
        997,
        1000,
        1001
    ],
    "tiemacèwè": [
        1014
    ],
    "tiema ciewe": [
        1014
    ],
    "tiema": [
        1014
    ],
    "tiemacewe": [
        1014
    ],
    "tiemacèwè bozo": [
        1014
    ],
    "tièma cièwè": [
        1014
    ],
    "tièma": [
        1014
    ],
    "tièma cèwè": [
        1014
    ],
    "tièmacèwè": [
        1014
    ],
    "tié": [
        1014
    ],
    "tuwuli": [
        1020
    ],
    "tuwili": [
        1020
    ],
    "tieyaxo": [
        1024,
        1025
    ],
    "tie": [
        1024,
        1025,
        1340,
        8898
    ],
    "tiemaxo": [
        1024,
        1025
    ],
    "tigemaxo": [
        1024,
        1025
    ],
    "tiguémakho": [
        1024,
        1025
    ],
    "tiéyakho": [
        1024,
        1025
    ],
    "tiéyaxo bozo": [
        1024,
        1025
    ],
    "tiéyaxo": [
        1024,
        1025
    ],
    "tyeyaxo": [
        1024,
        1025
    ],
    "tégué": [
        1024,
        1025
    ],
    "talk": [
        1035,
        3315,
        5302,
        6310
    ],
    "tagalagad": [
        1041
    ],
    "tumanao": [
        1042
    ],
    "timur": [
        1160,
        1161,
        1049,
        4870,
        6349,
        6512,
        6581,
        7704
    ],
    "tchumbuli": [
        1050
    ],
    "tchombolo": [
        1050
    ],
    "tshummbuli": [
        1050
    ],
    "to pu": [
        1057
    ],
    "tri": [
        1100,
        1101,
        1102
    ],
    "tutong": [
        7761,
        1117
    ],
    "tenda basari": [
        1118
    ],
    "tenda": [
        1118,
        1579,
        7629
    ],
    "taibano": [
        1129
    ],
    "taiwaeno": [
        1129
    ],
    "taiwano": [
        1129
    ],
    "teiuana": [
        1129
    ],
    "tchitem": [
        1131
    ],
    "temne": [
        1139,
        1140,
        7419
    ],
    "tomo": [
        1986,
        1158
    ],
    "tobote": [
        1173,
        1174
    ],
    "to ugi": [
        1177,
        1178
    ],
    "terei": [
        1185
    ],
    "telei": [
        1185
    ],
    "tchikai": [
        1213
    ],
    "twi": [
        1246
    ],
    "tairaha": [
        1248
    ],
    "tinitianes": [
        1271
    ],
    "tibin": [
        1280
    ],
    "talamanca": [
        1299
    ],
    "taurap": [
        1317
    ],
    "touho": [
        1340
    ],
    "tyamuhi": [
        1340
    ],
    "tchambuli": [
        1341
    ],
    "tshamberi": [
        1341
    ],
    "tsimané": [
        1346
    ],
    "tarapecosi": [
        1349
    ],
    "tea": [
        4220,
        1353
    ],
    "tsahá": [
        1354
    ],
    "taara": [
        1355
    ],
    "tchabè": [
        1357
    ],
    "tsábε": [
        1357
    ],
    "tsucuba": [
        1363
    ],
    "tsaawí": [
        1366
    ],
    "tshaahui": [
        1366
    ],
    "tschopi": [
        1374
    ],
    "txitxopi": [
        1374
    ],
    "txopi": [
        1374
    ],
    "tikk": [
        1375
    ],
    "tsamba": [
        1375,
        6986
    ],
    "takam": [
        1381,
        1382,
        1383,
        1384,
        5045,
        5046,
        5047
    ],
    "tsakma": [
        1381,
        1382,
        1383,
        1384
    ],
    "tsepang": [
        1395,
        1396
    ],
    "tsaudangsi": [
        1397
    ],
    "tiyal": [
        1401
    ],
    "tiyar": [
        1401
    ],
    "tucipu": [
        1401
    ],
    "tu’yara": [
        1401
    ],
    "tuu": [
        1416
    ],
    "ta-aw": [
        1421
    ],
    "tuum": [
        1423
    ],
    "tariya": [
        1426,
        6228
    ],
    "tera": [
        7771,
        1426
    ],
    "terea": [
        1426
    ],
    "teriya": [
        1426
    ],
    "terri": [
        1426
    ],
    "tipura": [
        1428,
        1429,
        1430,
        1431,
        1432,
        7662,
        7663,
        7714,
        7715
    ],
    "tsagkaglingpa’ikha": [
        1436
    ],
    "tsamang": [
        1436
    ],
    "tjamoro": [
        1437
    ],
    "tsome": [
        1440
    ],
    "tequistlatec": [
        1440
    ],
    "tsame": [
        1440
    ],
    "tabasco": [
        1441,
        5447,
        9117
    ],
    "tabasco chontal": [
        1441
    ],
    "tschagataisch": [
        1442
    ],
    "truk": [
        1445
    ],
    "trukese": [
        1445
    ],
    "tsinuk wawa": [
        1449,
        1450
    ],
    "tsinuk": [
        1449,
        1450
    ],
    "tsalagi": [
        1455,
        1456
    ],
    "tslagi": [
        1455,
        1456
    ],
    "tinganeses": [
        1457
    ],
    "txuwabo": [
        1458
    ],
    "tsitsistas": [
        1460
    ],
    "tsėhesenėstsestȯtse": [
        1460
    ],
    "tchi": [
        1465
    ],
    "thebarskad": [
        1470,
        3400,
        6737
    ],
    "tsitkhuli": [
        1470
    ],
    "tsíhuli": [
        1470
    ],
    "tzimbro": [
        1471
    ],
    "tîrî": [
        1474
    ],
    "tinrin": [
        1474
    ],
    "tiri": [
        1474,
        7017,
        7018,
        7022,
        8849
    ],
    "tiri-mea": [
        1474
    ],
    "tjam": [
        1478,
        1479,
        1480,
        1485,
        1486,
        1487
    ],
    "tscham": [
        1478
    ],
    "tsiam": [
        1478
    ],
    "tchokwé": [
        1484
    ],
    "tschiokloe": [
        1484
    ],
    "tschiokwe": [
        1484
    ],
    "tshokwe": [
        1484
    ],
    "thành": [
        1485,
        1486,
        1487
    ],
    "tsenap": [
        1488
    ],
    "tatar": [
        7753,
        7754,
        1604,
        1605,
        1606,
        7182,
        1491,
        1492,
        1527,
        3337,
        3338,
        3705,
        5624
    ],
    "tom-kuznets tatar": [
        1491,
        1492
    ],
    "tom-kuznets": [
        1491,
        1492
    ],
    "tjuave": [
        1493
    ],
    "thet": [
        1499,
        9061
    ],
    "tsak": [
        1499
    ],
    "tchokossi": [
        1504
    ],
    "tiokossi": [
        1504
    ],
    "tadimini": [
        1505
    ],
    "tayo": [
        1507
    ],
    "tsilhqút’ín": [
        1515
    ],
    "tzilkotin": [
        1515
    ],
    "tŝinlhqot’in": [
        1515
    ],
    "tshala": [
        1522
    ],
    "tallumpanuae": [
        1533
    ],
    "tasing": [
        1533
    ],
    "tjampalagian": [
        1533
    ],
    "tsotsitaal": [
        1540,
        2402
    ],
    "tuishiip": [
        1542
    ],
    "tuiship": [
        1542
    ],
    "tepetotutla": [
        1555
    ],
    "tepetotutla chinantec": [
        1555
    ],
    "tsafiki": [
        1565
    ],
    "tsachela": [
        1565
    ],
    "tsachila": [
        1565
    ],
    "tsafiqui": [
        1565
    ],
    "teresa": [
        1569
    ],
    "tekwapʉ": [
        1571
    ],
    "tutuni-chasta costa-coquille": [
        1577
    ],
    "tutuni-chasta": [
        1577
    ],
    "tlatepuzco": [
        1584
    ],
    "tili": [
        1604,
        1605,
        1606,
        3455,
        3456,
        3457,
        3548,
        3549,
        3728,
        3730,
        3731,
        3733,
        4129,
        4130,
        4131,
        8038,
        8039,
        8040,
        8042,
        8043
    ],
    "tomense": [
        1607
    ],
    "tereseño": [
        1615
    ],
    "tutet": [
        1621
    ],
    "tamun": [
        1622
    ],
    "takelne": [
        1623,
        1624
    ],
    "takulie": [
        1623,
        1624
    ],
    "tataltepec": [
        1656
    ],
    "tataltepec chatino": [
        1656
    ],
    "tedim": [
        1658,
        1659
    ],
    "tedim chin": [
        1658,
        1659
    ],
    "tiddim": [
        1658,
        1659
    ],
    "tidim": [
        1658,
        1659
    ],
    "tepinapa": [
        1660
    ],
    "tepinapa chinantec": [
        1660
    ],
    "thaiphum": [
        1664
    ],
    "thaiphum chin": [
        1664
    ],
    "thui phum": [
        1664
    ],
    "thui": [
        1664
    ],
    "tlacoatzintepec": [
        1665
    ],
    "tlacoatzintepec chinantec": [
        1665
    ],
    "teli": [
        1667
    ],
    "tila": [
        1673
    ],
    "tumala": [
        6633,
        1674
    ],
    "tule kaya": [
        1687
    ],
    "tule": [
        1687,
        4058
    ],
    "teutila": [
        1693
    ],
    "teutila cuicatec": [
        1693
    ],
    "tai ya": [
        1694
    ],
    "tai chung": [
        1694
    ],
    "tai cung": [
        1694
    ],
    "tai-chung": [
        1694
    ],
    "tai-cung": [
        1694
    ],
    "tchouvok": [
        1695
    ],
    "tepeuxila": [
        1697
    ],
    "tepeuxila cuicatec": [
        1697
    ],
    "tsinghwele": [
        1705
    ],
    "teotepec chatino": [
        1710
    ],
    "teotepec": [
        1710
    ],
    "tidama’un": [
        1733
    ],
    "tuivang": [
        1737
    ],
    "taita": [
        1743
    ],
    "teita": [
        8653,
        1743
    ],
    "turu": [
        1751,
        6524,
        8451,
        8943
    ],
    "tey": [
        1763,
        1766
    ],
    "tatitati": [
        1771
    ],
    "tharrthi-tharrthi": [
        1771
    ],
    "tjaru": [
        1776
    ],
    "tsez": [
        1778
    ],
    "tsezy": [
        1778
    ],
    "tsuntin": [
        1778
    ],
    "tedesco": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "tudestg": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "tysk": [
        1782,
        1785,
        1787,
        1791,
        1792
    ],
    "thakik": [
        1793
    ],
    "tha’": [
        1804,
        1805
    ],
    "tghuade": [
        1819
    ],
    "toghwede": [
        1819
    ],
    "traude": [
        1819
    ],
    "tlicho": [
        1826
    ],
    "tłı̨chǫ yatıì": [
        1826
    ],
    "tłı̨chǫ": [
        1826
    ],
    "thlingchadine": [
        1826
    ],
    "tłı̨chǫ": [
        1826
    ],
    "taungurong": [
        1830
    ],
    "taungurung": [
        1830
    ],
    "thagawurung": [
        1830
    ],
    "thagungwurrung": [
        1830
    ],
    "talaindji": [
        1835
    ],
    "talandi": [
        1835
    ],
    "talandji": [
        1835
    ],
    "talangee": [
        1835
    ],
    "tallainga": [
        1835
    ],
    "taloinga": [
        1835
    ],
    "thalantji": [
        1835
    ],
    "thalanyji": [
        1835
    ],
    "tjimba": [
        1836
    ],
    "tadavi": [
        1837
    ],
    "tadvi bhil": [
        1837
    ],
    "tadvi": [
        1837
    ],
    "targari": [
        1839
    ],
    "tarkarri": [
        1839
    ],
    "thargari": [
        1839
    ],
    "tharrgari": [
        1839
    ],
    "tharrkari": [
        1839
    ],
    "tharumba": [
        1841
    ],
    "thaua": [
        1841
    ],
    "thoorga": [
        1841
    ],
    "thurga": [
        1841
    ],
    "thuɔŋjäŋ": [
        1846,
        1856,
        1857,
        1859,
        1864,
        1890
    ],
    "toi": [
        1848
    ],
    "tiipay": [
        1851
    ],
    "tipai’": [
        1851
    ],
    "tipái": [
        1851
    ],
    "tipéi": [
        1851
    ],
    "tongo": [
        7113,
        1878,
        1879
    ],
    "tegu": [
        1992,
        1880,
        1991
    ],
    "tidung": [
        3266,
        5710,
        1889,
        6708
    ],
    "tindal": [
        1889,
        7508
    ],
    "tchakidjebe": [
        1900
    ],
    "tebi": [
        1909
    ],
    "tungan": [
        1917,
        4735
    ],
    "tulem": [
        1925
    ],
    "taruw": [
        1927
    ],
    "täruw": [
        1927
    ],
    "timorini": [
        1928
    ],
    "tong": [
        1932,
        3794,
        3795,
        5938,
        7769,
        7477,
        7672
    ],
    "tung": [
        1932,
        3794,
        3795,
        6720,
        6721
    ],
    "tung-chia": [
        1932,
        3794,
        3795
    ],
    "tokkaru": [
        1936,
        1937,
        1938
    ],
    "toura": [
        1941,
        5390
    ],
    "toura (papua new guinea)": [
        1941
    ],
    "toka-leya-dombe": [
        1948
    ],
    "tunga": [
        1949
    ],
    "tungbo": [
        1949
    ],
    "tuuno": [
        1949
    ],
    "thaminyi": [
        1954
    ],
    "taloma": [
        1966
    ],
    "tsalisen": [
        1966
    ],
    "tsarisen": [
        1966
    ],
    "tegnsprog": [
        1972
    ],
    "tadaksahak": [
        1975,
        1976
    ],
    "tahuerh": [
        1977,
        1978,
        1979,
        1980
    ],
    "tahur": [
        1977,
        1978,
        1979,
        1980
    ],
    "tinangaran kadajan": [
        1981
    ],
    "tinangaran": [
        1981
    ],
    "tindakon": [
        1981
    ],
    "tompulung": [
        1981
    ],
    "tinga": [
        1984
    ],
    "tene": [
        1985
    ],
    "tene kan": [
        1985
    ],
    "tene kan dogon": [
        1985
    ],
    "tene tingi": [
        1985
    ],
    "tingi": [
        1985
    ],
    "tengu kan": [
        1985
    ],
    "tengu": [
        1985,
        7407,
        7408
    ],
    "togo kan": [
        1985
    ],
    "tomo kan dogon": [
        1986
    ],
    "tomo-kan": [
        1986
    ],
    "tommo": [
        1988
    ],
    "tombo-so": [
        1988
    ],
    "tommo so": [
        1988
    ],
    "tommo so dogon": [
        1988
    ],
    "toro": [
        7404,
        1991,
        1992,
        7764,
        3315
    ],
    "toro so": [
        1991
    ],
    "toro so dogon": [
        1991
    ],
    "tandam": [
        1992
    ],
    "toro tegu dogon": [
        1992
    ],
    "tebul": [
        7751,
        1993
    ],
    "tebul ure": [
        1993
    ],
    "tebul ure dogon": [
        1993
    ],
    "talavia": [
        1996
    ],
    "taron": [
        2013,
        6477,
        6478,
        6479,
        6480,
        6481,
        6482
    ],
    "tarong": [
        2013
    ],
    "thrung": [
        2013
    ],
    "trone": [
        2013
    ],
    "trung": [
        2013
    ],
    "tulung": [
        2013
    ],
    "tvrung": [
        2013
    ],
    "t’rung": [
        2013
    ],
    "tsagu": [
        2022,
        7449
    ],
    "tangetti": [
        2037
    ],
    "thangatti": [
        2037
    ],
    "thangatty": [
        2037
    ],
    "tagboussikan": [
        2040,
        2041,
        2042
    ],
    "trade jula": [
        2040,
        2041,
        2042
    ],
    "trade": [
        2040,
        2041,
        2042
    ],
    "tjabakai-thandji": [
        2043
    ],
    "tjabogaijanji": [
        2043
    ],
    "tjankir": [
        2043
    ],
    "tjankun": [
        2043
    ],
    "tjapukai": [
        2043
    ],
    "tjapunkandji": [
        2043
    ],
    "tjunbundji": [
        2043
    ],
    "tunzuii": [
        2045
    ],
    "tunzu": [
        2045
    ],
    "tivali": [
        2046
    ],
    "tjiwali": [
        2046
    ],
    "tjiwarli": [
        2046
    ],
    "tebu": [
        2047,
        7797
    ],
    "teda-daza": [
        2047,
        7797
    ],
    "toubou": [
        2047,
        7797
    ],
    "tubu": [
        6362,
        2047,
        7797
    ],
    "teke-eboo": [
        2054
    ],
    "teke": [
        7418,
        2054,
        3151,
        3298,
        3759,
        4382,
        5444,
        5819,
        7415,
        7864,
        7876
    ],
    "teke, eboo": [
        2054
    ],
    "teke-boma": [
        2054
    ],
    "teke-ebo": [
        2054
    ],
    "tchaman": [
        2055
    ],
    "tsama": [
        2055
    ],
    "tyama": [
        2055
    ],
    "t-valley": [
        2073
    ],
    "tapiro": [
        2081
    ],
    "tekó": [
        2104
    ],
    "teco": [
        2104,
        7757
    ],
    "territory": [
        2166
    ],
    "tristan": [
        2204
    ],
    "tc": [
        2211,
        7362
    ],
    "turks and caicos islands": [
        2211,
        7362
    ],
    "turks": [
        7362,
        2211
    ],
    "tk": [
        2212,
        7542
    ],
    "tokelau": [
        7542,
        2212
    ],
    "tonga": [
        7643,
        7644,
        7645,
        3793,
        7637,
        7727,
        7728,
        7638,
        2213,
        5526,
        5736
    ],
    "tt": [
        2214,
        4503,
        7452,
        7705
    ],
    "trinidad and tobago": [
        2214,
        4503,
        7452,
        7705
    ],
    "trinidad": [
        4503,
        3013,
        2214,
        7452,
        7705
    ],
    "tobago": [
        4503,
        7314,
        2214,
        7452,
        7705
    ],
    "tv": [
        2215,
        7808
    ],
    "tuvalu": [
        7808,
        2215
    ],
    "tundra": [
        2232,
        8816
    ],
    "tundra enets": [
        2232
    ],
    "tchaga": [
        2237
    ],
    "tsaga": [
        2237
    ],
    "t’osu": [
        2253
    ],
    "tambopata-guarayo": [
        2286
    ],
    "tiatinagua": [
        2286
    ],
    "ten": [
        6203,
        2314,
        8675,
        4824
    ],
    "tungus": [
        2320,
        2321,
        2322
    ],
    "tungus ewenki": [
        2320,
        2321,
        2322
    ],
    "toucouleur": [
        2378,
        2379
    ],
    "torne valley finnish": [
        2391
    ],
    "torne": [
        2391
    ],
    "tornedalen finnish": [
        2391
    ],
    "tornedalen": [
        2391
    ],
    "tornedalsfinska": [
        2391
    ],
    "taal": [
        2402
    ],
    "tnebar": [
        2467
    ],
    "teckenspråk": [
        2478,
        7239
    ],
    "taareyo": [
        2479,
        2480
    ],
    "talo": [
        2521
    ],
    "tangkic": [
        2566
    ],
    "tovar": [
        2572
    ],
    "tiara": [
        2578
    ],
    "tchade": [
        2579
    ],
    "tcheke": [
        2579
    ],
    "temiang": [
        2601
    ],
    "tirolean": [
        2603
    ],
    "tyrolese": [
        2603
    ],
    "tsheenya": [
        2613
    ],
    "taghumarit": [
        2634
    ],
    "tamazight": [
        7496,
        7527,
        7884,
        7885,
        7886,
        9014,
        2634,
        3458,
        3459,
        3460,
        6519,
        6520,
        6521,
        6522,
        6906
    ],
    "tahari": [
        2636
    ],
    "tchere": [
        2652
    ],
    "telue": [
        2655
    ],
    "tú du": [
        2655
    ],
    "tú": [
        2655
    ],
    "tourahonong": [
        2661
    ],
    "taataal": [
        2676
    ],
    "tala": [
        7311,
        2690,
        8209
    ],
    "taribelang": [
        2718
    ],
    "taribeleng": [
        2718
    ],
    "tarribelung": [
        2718
    ],
    "tulua": [
        2718
    ],
    "thuntai": [
        2719
    ],
    "tayap": [
        2755
    ],
    "taiap": [
        2755
    ],
    "tugbiri-niragu": [
        2769
    ],
    "tugbiri": [
        2769
    ],
    "tangarare": [
        2770
    ],
    "talantang": [
        2772
    ],
    "tromawa": [
        2773
    ],
    "tromowa": [
        2773
    ],
    "taznatit": [
        2775
    ],
    "tharnggala": [
        2799
    ],
    "tharnggalai": [
        2799
    ],
    "tharnggalu": [
        2799,
        3184
    ],
    "tenetehar": [
        2804
    ],
    "tenetehára": [
        2804
    ],
    "trik": [
        2814
    ],
    "tamu kyi": [
        2837,
        2838
    ],
    "tamu": [
        2837,
        2838
    ],
    "takudh": [
        2848
    ],
    "tukkuthkutchin": [
        2848
    ],
    "tukudh": [
        2848
    ],
    "tapacura": [
        2868
    ],
    "tr’ondëk hwëch’in": [
        2882
    ],
    "tr’ondëk": [
        2882
    ],
    "tu guangdonghua": [
        2893,
        2894,
        2895
    ],
    "taduaguay": [
        2897
    ],
    "tshuwau": [
        2950
    ],
    "tati": [
        2950,
        3341,
        3342,
        3343,
        7331,
        7549,
        7773,
        7774,
        7775
    ],
    "tati bushman": [
        2950
    ],
    "tshikwa": [
        2950
    ],
    "tshwa": [
        2950,
        7731
    ],
    "tshwao": [
        2950
    ],
    "tshwawo": [
        2950
    ],
    "tsoa": [
        2950
    ],
    "tsua": [
        2950
    ],
    "tasi": [
        2964
    ],
    "tribe": [
        2973,
        2974,
        2975,
        8619
    ],
    "ta hwa miao": [
        2973,
        2974,
        2975
    ],
    "ta": [
        3786,
        2973,
        2974,
        2975,
        6717,
        7750,
        7762
    ],
    "tsis": [
        2986
    ],
    "tau": [
        5457,
        7762,
        2986,
        4425
    ],
    "ts’exa": [
        3003
    ],
    "ts’éxa": [
        3003
    ],
    "tsi": [
        3005,
        3006,
        3007,
        3008,
        3009,
        7522,
        7529
    ],
    "tak miao": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "tak": [
        3005,
        3006,
        3007,
        3008,
        3009
    ],
    "trinidad bhojpuri": [
        3013
    ],
    "trinidadian bhojpuri": [
        3013
    ],
    "trinidadian": [
        7705,
        3013,
        4503
    ],
    "trinidadian hindustani": [
        3013
    ],
    "tanga": [
        3046
    ],
    "tachom": [
        3047,
        3048
    ],
    "tenae": [
        3054
    ],
    "tindiga": [
        3067
    ],
    "tsat": [
        3086
    ],
    "teenek": [
        3088
    ],
    "tenek": [
        3088
    ],
    "tének": [
        3088
    ],
    "tuftera": [
        3103
    ],
    "táknmál": [
        3129
    ],
    "tame": [
        3139
    ],
    "tuwali": [
        3150
    ],
    "tuwali ifugao": [
        3150
    ],
    "teke-fuumu": [
        3151
    ],
    "teke du pool": [
        3151
    ],
    "thiin": [
        3171
    ],
    "teen": [
        3171
    ],
    "teenma": [
        3171
    ],
    "tenma": [
        3171
    ],
    "thenma": [
        3171
    ],
    "thiinma": [
        3171
    ],
    "teus": [
        3190
    ],
    "teuso": [
        3190
    ],
    "teuth": [
        3190
    ],
    "turki": [
        3195,
        6443,
        7694,
        7695,
        7696,
        7698,
        7699
    ],
    "taranchi": [
        3195
    ],
    "tuerke": [
        3195
    ],
    "tu’erke": [
        3195
    ],
    "t’urk": [
        3195
    ],
    "tuma-irumu": [
        3229
    ],
    "tatuma-irumu": [
        3229
    ],
    "tuma": [
        3229
    ],
    "teanga chomharthaíochta na héireann": [
        3250
    ],
    "teanga": [
        3250
    ],
    "talijanski": [
        3260,
        3261
    ],
    "talyaaniga": [
        3260,
        3261
    ],
    "tingguian": [
        3265
    ],
    "tidung, southern": [
        3266
    ],
    "tedong": [
        3266,
        5710
    ],
    "tidoeng": [
        3266,
        5710,
        6708
    ],
    "tidong": [
        3266,
        5710,
        6708
    ],
    "tiran": [
        3266,
        5710
    ],
    "tirones": [
        3266,
        5710
    ],
    "tiroon": [
        3266,
        5710
    ],
    "teneyo": [
        3273
    ],
    "tshekeri": [
        3274
    ],
    "tawit": [
        3276
    ],
    "thanh": [
        7601,
        3283,
        3284,
        3285,
        3286,
        3287,
        4824,
        7870
    ],
    "taak": [
        3315
    ],
    "tchandi": [
        3316
    ],
    "tunisian berber": [
        3330
    ],
    "takum": [
        3334
    ],
    "takum-donga": [
        3334
    ],
    "tat": [
        7773,
        7774,
        7775,
        3341,
        3342,
        3343
    ],
    "tol": [
        3364
    ],
    "tolpan": [
        3364
    ],
    "tolupan": [
        3364
    ],
    "torrupan": [
        3364
    ],
    "tchingalee": [
        3367
    ],
    "tjingili": [
        3367
    ],
    "tjingilu": [
        3367
    ],
    "thalwepwe": [
        3383
    ],
    "taloka": [
        3387
    ],
    "tanempar liriny": [
        3392
    ],
    "tanempar": [
        3392
    ],
    "tanemprar lirin": [
        3392
    ],
    "tanemprar": [
        3392
    ],
    "to’on savi": [
        3399,
        4804
    ],
    "to’on": [
        3399,
        4804
    ],
    "thebor": [
        3400,
        6737,
        7139
    ],
    "thebör skadd": [
        3400,
        6737,
        7139
    ],
    "thebör": [
        3400,
        6737,
        7139
    ],
    "tijanji": [
        3403
    ],
    "tupe": [
        3418
    ],
    "temane": [
        3425
    ],
    "tüŋ mäbaan": [
        3434
    ],
    "tüŋ": [
        3434
    ],
    "tofa": [
        3682,
        7875,
        3442
    ],
    "tchorny": [
        3455,
        3456,
        3457
    ],
    "taqbaylit": [
        3458,
        3459,
        3460
    ],
    "tazwawt": [
        3458,
        3459,
        3460
    ],
    "tangalan": [
        3463
    ],
    "tüküná": [
        3474,
        3831
    ],
    "tɔm": [
        3492,
        3493
    ],
    "tyap": [
        3512
    ],
    "tjikalanga": [
        3516
    ],
    "tar gula": [
        3518
    ],
    "tshikete": [
        3527
    ],
    "tabelbala": [
        3530
    ],
    "tem": [
        3538,
        3539
    ],
    "temba": [
        3538,
        3539
    ],
    "tembe": [
        3538,
        3539
    ],
    "tim": [
        3538,
        3539
    ],
    "timu": [
        3538,
        3539
    ],
    "touaouru": [
        3542
    ],
    "truaru": [
        3542
    ],
    "tuauru": [
        3542
    ],
    "tsikimba": [
        3543
    ],
    "turkic karaite": [
        3548,
        3549
    ],
    "tamya": [
        3553
    ],
    "tese": [
        3564
    ],
    "teis-umm-danab": [
        3564
    ],
    "these": [
        3564
    ],
    "tshuosh": [
        3565
    ],
    "tshwosh": [
        3565
    ],
    "tibas skad": [
        3601,
        3602
    ],
    "tibas": [
        3601,
        3602
    ],
    "thinglong": [
        3615
    ],
    "tellem": [
        3619
    ],
    "tabanya": [
        3632
    ],
    "tai lu": [
        3645,
        3646
    ],
    "tai lue": [
        3645,
        3646
    ],
    "thai lu": [
        3645,
        3646
    ],
    "tukang besi north": [
        3647
    ],
    "tibetan, khams": [
        3651
    ],
    "timbuktu songhoy": [
        3659
    ],
    "timbuktu": [
        3659,
        7316,
        7317
    ],
    "ti": [
        7322,
        7853,
        3663,
        4208,
        4519,
        4722,
        4774
    ],
    "tai kam ti": [
        3663
    ],
    "tai kham ti": [
        3663
    ],
    "tai-khamti": [
        3663
    ],
    "teri-kalwasch": [
        3677
    ],
    "tofalar": [
        3682
    ],
    "tukhemmi": [
        3691
    ],
    "tiro": [
        3698,
        7497
    ],
    "terng": [
        3702,
        3703,
        3704
    ],
    "thenh": [
        3702,
        3703,
        3704
    ],
    "tenh": [
        3702,
        3703,
        3704
    ],
    "theng": [
        3702,
        3703,
        3704,
        3710
    ],
    "tmooy": [
        3702,
        3703,
        3704
    ],
    "takale": [
        3709
    ],
    "takale kham": [
        3709
    ],
    "tay hay": [
        3710
    ],
    "tay": [
        7319,
        7322,
        3710,
        5745,
        7632,
        7865,
        7866,
        7872,
        7873
    ],
    "tayhay": [
        3710
    ],
    "teng": [
        3710
    ],
    "taogwe": [
        3736
    ],
    "tomu": [
        3737
    ],
    "tomu river": [
        3737
    ],
    "tinu": [
        3738
    ],
    "tsangla monpa": [
        3741
    ],
    "tsangla": [
        3741,
        7738
    ],
    "tai khun": [
        3743
    ],
    "tai-khuen": [
        3743
    ],
    "tumi": [
        3757
    ],
    "tutumi": [
        3757
    ],
    "teke-kukuya": [
        3759
    ],
    "tagakaulo": [
        3770
    ],
    "tagakaolo": [
        3770
    ],
    "tagakaulu kalagan": [
        3770
    ],
    "tagakaulu": [
        3770
    ],
    "turkic khalaj": [
        3773
    ],
    "tumu": [
        3780,
        6877
    ],
    "tado": [
        3787
    ],
    "tho": [
        7654,
        3791,
        7878,
        9188
    ],
    "tanudan": [
        3804
    ],
    "tanudan kalinga": [
        3804
    ],
    "tuan": [
        3810
    ],
    "tâkâna": [
        3831
    ],
    "tiong": [
        3838,
        3839
    ],
    "tabo": [
        3842
    ],
    "tehit": [
        3891
    ],
    "tahit": [
        3891
    ],
    "tehid": [
        3891
    ],
    "teminabuan": [
        3891
    ],
    "taulu til": [
        3929
    ],
    "taulu": [
        3929
    ],
    "til": [
        3929
    ],
    "tikurami": [
        3933
    ],
    "tumari": [
        3943
    ],
    "tumari kanuri": [
        3943
    ],
    "tinata tuna": [
        3957
    ],
    "tinata": [
        3957
    ],
    "tuna": [
        3957,
        8110
    ],
    "tolai": [
        3957
    ],
    "tai khamyang": [
        3974
    ],
    "tai nora": [
        3974,
        5676
    ],
    "thar": [
        3979,
        4853,
        4854,
        4156,
        4157,
        4158
    ],
    "tua": [
        3981
    ],
    "tlokeang": [
        4003
    ],
    "tshumkwe": [
        4006
    ],
    "tsumkwe": [
        4006
    ],
    "tof": [
        4025
    ],
    "tannin": [
        4059
    ],
    "taru": [
        4065,
        7368
    ],
    "tarulakhi": [
        4065
    ],
    "taliak": [
        4070
    ],
    "tsaukambo": [
        4071
    ],
    "tsakwambo": [
        4071
    ],
    "tsokwambo": [
        4071
    ],
    "tekutameso": [
        4077,
        8408
    ],
    "tà sàra": [
        4079
    ],
    "tà": [
        4079,
        5185
    ],
    "thailand khmer": [
        4111,
        4112
    ],
    "thradhri": [
        4117
    ],
    "tai khang": [
        7632,
        4147
    ],
    "taar cɛŋɛ": [
        4148
    ],
    "taar": [
        4148,
        7278
    ],
    "tarali kham": [
        4176
    ],
    "tarali": [
        4176
    ],
    "tanggal": [
        4178
    ],
    "tilau-ilau": [
        4178
    ],
    "tumbulalá": [
        4181
    ],
    "tshopo": [
        4183
    ],
    "tzoudeo-espaniol": [
        4189,
        4190,
        4191
    ],
    "tinombo": [
        4212
    ],
    "tiwa": [
        4213,
        4214,
        7517,
        7823
    ],
    "transylvanian saxon": [
        4217
    ],
    "transylvanian": [
        4217
    ],
    "tai laka": [
        4220
    ],
    "tea mountain yao": [
        4220
    ],
    "tinani": [
        4222,
        4223
    ],
    "tinan": [
        4222,
        4223
    ],
    "teenan": [
        4222,
        4223
    ],
    "tinan lahuli": [
        4222,
        4223
    ],
    "tai lati": [
        4235
    ],
    "tolaki": [
        4238
    ],
    "tokia": [
        4238
    ],
    "tololaki": [
        4238
    ],
    "to’olaki": [
        4238
    ],
    "tungag": [
        4248
    ],
    "toangai": [
        4248
    ],
    "tungak": [
        4248
    ],
    "tiapi": [
        4261
    ],
    "tyapi": [
        4261
    ],
    "tyopi": [
        4261
    ],
    "tso": [
        4264,
        7747,
        5729
    ],
    "tsó": [
        4264
    ],
    "tsóbó": [
        4264
    ],
    "tiki": [
        4279
    ],
    "tungidjo": [
        4279
    ],
    "tungijo": [
        4279
    ],
    "tɨ": [
        4300,
        4301
    ],
    "t'apo": [
        4307
    ],
    "tadhimboko": [
        4309
    ],
    "taba-damey-bikha": [
        4319
    ],
    "tsie": [
        4331
    ],
    "tuba": [
        4331,
        7875
    ],
    "toriko": [
        4334
    ],
    "tanah kunu": [
        4352
    ],
    "tshangkha": [
        4362
    ],
    "teton": [
        4371
    ],
    "teton sioux": [
        4371
    ],
    "tarawalla": [
        4372
    ],
    "torra-burri": [
        4372
    ],
    "tengah": [
        6924,
        4380,
        6311,
        7835
    ],
    "teke-laali": [
        4382
    ],
    "tanda": [
        4406,
        4407,
        4408,
        8784
    ],
    "tai lao": [
        4439
    ],
    "toa": [
        4451,
        4452,
        7641
    ],
    "turumbu": [
        4454
    ],
    "téén": [
        4457
    ],
    "tegesie": [
        4457
    ],
    "touni": [
        4457
    ],
    "tuni": [
        4457
    ],
    "ténhé": [
        4457
    ],
    "tampias": [
        4463
    ],
    "tampias lobu": [
        4463
    ],
    "tozvi": [
        4467
    ],
    "tibetan sign language": [
        4498
    ],
    "tsl": [
        4498,
        4503,
        6603,
        7743
    ],
    "tibsl": [
        4498
    ],
    "trinidad and tobago sign language": [
        4503
    ],
    "ttsl": [
        4503
    ],
    "trinidad sign language": [
        4503
    ],
    "trinidadian sign language": [
        4503
    ],
    "thur": [
        4511
    ],
    "tsotso": [
        4514
    ],
    "tachon": [
        4515
    ],
    "tachoni": [
        4515
    ],
    "tatsoni": [
        4515
    ],
    "tshiluba": [
        4517,
        4518
    ],
    "tị": [
        4519
    ],
    "tị": [
        4526
    ],
    "twang": [
        4533,
        4534,
        4535,
        7217
    ],
    "tecóatl": [
        4571
    ],
    "tu’un savi": [
        4572,
        4629,
        4796,
        4799,
        4803,
        4816,
        5121,
        8113,
        8118,
        8652,
        8654,
        8658,
        8664,
        8667
    ],
    "tu’un": [
        4572,
        4629,
        4796,
        4799,
        4803,
        4816,
        4817,
        4819,
        5016,
        5121,
        5205,
        5206,
        5223,
        5226,
        5255,
        8113,
        8118,
        8652,
        8654,
        8658,
        8664,
        8667
    ],
    "thenthi": [
        4577,
        4578,
        4579,
        4580
    ],
    "tirahutia": [
        4577,
        4578,
        4579,
        4580
    ],
    "tirhuti": [
        4577,
        4578,
        4579,
        4580
    ],
    "tirhutia": [
        4577,
        4578,
        4579,
        4580
    ],
    "taena": [
        4582,
        4583,
        4584
    ],
    "ternate malay": [
        4598
    ],
    "ternate": [
        7441,
        4598
    ],
    "teueia": [
        4602
    ],
    "teweya": [
        4602
    ],
    "tikmũ'ũn yĩy'ax": [
        4610
    ],
    "tikmũũn": [
        4610
    ],
    "tikmuún": [
        4610
    ],
    "tikmũ’ũn yĩy’ax": [
        4610
    ],
    "tikmũ’ũn": [
        4610
    ],
    "tigwa": [
        4618
    ],
    "tigwa manobo": [
        4618
    ],
    "tnu’u ñuu savi": [
        4624
    ],
    "tnu’u": [
        4624,
        5157
    ],
    "towolhi": [
        4625
    ],
    "tsain": [
        4628
    ],
    "tì": [
        4643
    ],
    "tagbo": [
        4645,
        7341,
        5266
    ],
    "tongbo": [
        4645,
        5266
    ],
    "turama river kiwai": [
        4652
    ],
    "turama": [
        4652,
        6634
    ],
    "tengo": [
        4660
    ],
    "tas-sinjali": [
        4663
    ],
    "tlaxiaco": [
        4686,
        8656,
        4792,
        4996
    ],
    "tu̱ꞌun káꞌánꞌ kájí": [
        4686
    ],
    "tu̱ꞌun": [
        4686
    ],
    "tid": [
        4687,
        7741
    ],
    "tid-n-aal": [
        4687
    ],
    "tidda": [
        4687
    ],
    "true motu": [
        4701
    ],
    "true": [
        4701
    ],
    "tonko": [
        4735
    ],
    "teny ôfisialy": [
        4736,
        4738
    ],
    "teny": [
        4736,
        4738
    ],
    "terrutong": [
        4773
    ],
    "terutong": [
        4773
    ],
    "taaon": [
        4785
    ],
    "taraon": [
        4785
    ],
    "taying": [
        4785
    ],
    "thimbukushu": [
        4786
    ],
    "thimukushu": [
        4786
    ],
    "te reo māori": [
        4790
    ],
    "te reo": [
        4790
    ],
    "twatwa": [
        4791
    ],
    "twightwee": [
        4791
    ],
    "tu'un savi": [
        4796,
        4799,
        4803
    ],
    "tuun": [
        4796,
        4799,
        4803,
        4819,
        5255
    ],
    "tomás": [
        4796,
        9144
    ],
    "toꞌon savi": [
        4804
    ],
    "toꞌon": [
        4804
    ],
    "tu̱n savi̱ꞌ tu̱tyoo̱ꞌ": [
        4816
    ],
    "tu̱n": [
        4816
    ],
    "tu̱tyoo̱ꞌ": [
        4816
    ],
    "tuꞌun davi": [
        4817
    ],
    "tuꞌun": [
        4817,
        5206,
        5226
    ],
    "teotitlán mixtec": [
        4817
    ],
    "teotitlán": [
        4817
    ],
    "tu’un davi": [
        4817
    ],
    "tu'un sav": [
        4819
    ],
    "tu’un sav": [
        4819,
        5205,
        5223
    ],
    "tsamak": [
        4820
    ],
    "trang": [
        4824,
        5197,
        5198,
        5199,
        5200,
        5201
    ],
    "tunic": [
        4824
    ],
    "tin": [
        4879,
        4880,
        7435,
        7436,
        4824,
        7555
    ],
    "trouser": [
        4824
    ],
    "towetan": [
        4834
    ],
    "thari": [
        4853
    ],
    "tu̱hun ndáhví": [
        4864
    ],
    "tu̱hun": [
        4864
    ],
    "tamabo": [
        4875
    ],
    "thin": [
        4879,
        4880,
        6300,
        8735,
        6062,
        6063
    ],
    "t’in": [
        4879,
        4880
    ],
    "teha": [
        4887
    ],
    "to’abaita": [
        4894
    ],
    "to'abaita": [
        4894
    ],
    "toabaita": [
        4894
    ],
    "toqabaqita": [
        4894
    ],
    "to’aba’ita": [
        4894
    ],
    "to’ambaita": [
        4894
    ],
    "taman": [
        7365,
        7602,
        4897,
        7590
    ],
    "tomman": [
        4897
    ],
    "tirakh": [
        4905
    ],
    "tolongken": [
        4907
    ],
    "tapuyo": [
        4921
    ],
    "tiale": [
        4947
    ],
    "te hegeunga a mugaba ma mugiki": [
        4955
    ],
    "takanoon": [
        4956
    ],
    "talaing": [
        4956,
        6380
    ],
    "taleng": [
        4956
    ],
    "teguan": [
        4956
    ],
    "targoodi": [
        4993
    ],
    "targudi": [
        4993
    ],
    "tlazoyaltepec": [
        5016
    ],
    "tlazoyaltepec mixtec": [
        5016
    ],
    "tu’un dau": [
        5016
    ],
    "toraja": [
        5018,
        6581,
        6747
    ],
    "tabu": [
        5044
    ],
    "tahati": [
        5053
    ],
    "taung mru": [
        5054,
        5055
    ],
    "taung": [
        5054,
        5055,
        7368
    ],
    "tape": [
        5059
    ],
    "tobah": [
        5059
    ],
    "tugeri": [
        5066
    ],
    "teel": [
        5112
    ],
    "tehl": [
        5112
    ],
    "tel": [
        5112
    ],
    "totontepec": [
        5115
    ],
    "totontepec mixe": [
        5115
    ],
    "tututepec": [
        5121
    ],
    "tututepec mixtec": [
        5121
    ],
    "tidaá": [
        5124
    ],
    "tidaá mixtec": [
        5124
    ],
    "tnu’un dawi": [
        5124
    ],
    "tnu’un": [
        5124,
        8648
    ],
    "teteka": [
        5138
    ],
    "tnu’u savi": [
        5157
    ],
    "tahol": [
        5170
    ],
    "tagal": [
        5170
    ],
    "tagal murut": [
        5170
    ],
    "tagol": [
        5170
    ],
    "tà sàᶉ̄": [
        5185
    ],
    "tanoriki": [
        5187
    ],
    "torres": [
        7371,
        5188,
        7950
    ],
    "tráng": [
        5197,
        5198,
        5199,
        5200,
        5201,
        7825,
        7826
    ],
    "tezoatlán": [
        5206
    ],
    "tuꞌun ndaꞌi": [
        5206
    ],
    "tezoatlán mixtec": [
        5206
    ],
    "tu’un nda’i": [
        5206
    ],
    "tlahuitoltepec": [
        5220
    ],
    "tlahuitoltepec mixe": [
        5220
    ],
    "tuꞌun sávi": [
        5226
    ],
    "tu’un sávi": [
        5226
    ],
    "tuꞌun savi de metlatónoc y cochoapa el grande": [
        5226
    ],
    "tinta": [
        5237
    ],
    "tupiire": [
        5241
    ],
    "tabotiro jejea": [
        5253
    ],
    "tabotiro": [
        5253
    ],
    "tu'un va'a": [
        5255
    ],
    "tu’un va’a": [
        5255
    ],
    "tumzabt": [
        5256,
        5257,
        5258
    ],
    "tutla mixe": [
        5267
    ],
    "tutla": [
        5267
    ],
    "tabri": [
        5269
    ],
    "tyemeri": [
        5292
    ],
    "taiwanese": [
        5293,
        5294,
        5295,
        5296,
        5297
    ],
    "tama": [
        7420,
        7587,
        5300
    ],
    "tamakwa": [
        5300
    ],
    "tamma": [
        5300
    ],
    "tûm": [
        5337
    ],
    "tla’tol": [
        5343
    ],
    "tabele": [
        5358
    ],
    "tebele": [
        5358
    ],
    "tando": [
        5369
    ],
    "toura (côte d'ivoire)": [
        5390
    ],
    "tura": [
        5390,
        7726
    ],
    "towi": [
        5413
    ],
    "tibea": [
        5443
    ],
    "tabasco aztec": [
        5447
    ],
    "tabasco nahuatl": [
        5447
    ],
    "tsiripá": [
        5448
    ],
    "txiripá": [
        5448
    ],
    "tetelcingo": [
        5451
    ],
    "tetelcingo aztec": [
        5451
    ],
    "tetelcingo nahuatl": [
        5451
    ],
    "tepetzintla": [
        5453
    ],
    "tenango nahuatl": [
        5453
    ],
    "tenango": [
        5988,
        5453,
        7880
    ],
    "tlaxcala-puebla nahuatl": [
        5456
    ],
    "tlaxcala-puebla": [
        5456
    ],
    "takuu": [
        5457
    ],
    "taku": [
        5457
    ],
    "tauu": [
        5457
    ],
    "temascaltepec": [
        5463
    ],
    "temascaltepec aztec": [
        5463
    ],
    "temascaltepec nahuatl": [
        5463
    ],
    "tamazunchale": [
        5464
    ],
    "tatahuicapan nahuatl": [
        5465
    ],
    "tatahuicapan": [
        5465
    ],
    "tita": [
        7400,
        5480
    ],
    "tavgi samoyed": [
        5481
    ],
    "tavgi": [
        5481
    ],
    "tsindir": [
        5496
    ],
    "tsontsii": [
        5496
    ],
    "tendydie": [
        5500
    ],
    "tenyidie": [
        5500
    ],
    "tsanglo": [
        5500,
        7738
    ],
    "tsoghami": [
        5500
    ],
    "tsugumi": [
        5500
    ],
    "tchaakalaaga": [
        5506
    ],
    "thangal": [
        5519,
        5520
    ],
    "thangal naga": [
        5519,
        5520
    ],
    "thanggal": [
        5519,
        5520
    ],
    "thangkhal haam": [
        5519,
        5520
    ],
    "thangkhal": [
        5519,
        5520
    ],
    "tukaimi": [
        5519,
        5520
    ],
    "tarawara": [
        5552
    ],
    "tarawari": [
        5552
    ],
    "trawari": [
        5552
    ],
    "taut": [
        5562
    ],
    "tangkhul": [
        5566,
        5722
    ],
    "tagkhul": [
        5566
    ],
    "tangkhul naga (india)": [
        5566
    ],
    "thangkhulm": [
        5566
    ],
    "taa": [
        5576
    ],
    "tsasi": [
        5576
    ],
    "tjura": [
        5613
    ],
    "tyura": [
        5613
    ],
    "thai, northern": [
        5620,
        5621
    ],
    "tai nya": [
        5620,
        5621
    ],
    "trongsakha": [
        5642
    ],
    "tamlu": [
        5644
    ],
    "tamlu naga": [
        5644
    ],
    "tehuacán": [
        5645
    ],
    "tehuacán náhuatl": [
        5645
    ],
    "transvaal ndebele": [
        5661,
        5662
    ],
    "transvaal": [
        5661,
        5662,
        5695,
        5696
    ],
    "tegnspråk": [
        5692
    ],
    "transvaal sotho": [
        5695,
        5696
    ],
    "tangshang": [
        5701,
        5703,
        5702
    ],
    "tangsa": [
        5702,
        5701,
        5703
    ],
    "tangwa": [
        5701,
        5702,
        5703
    ],
    "tase": [
        5701,
        5702,
        5703
    ],
    "tase naga": [
        5701,
        5702,
        5703
    ],
    "tasey": [
        5701,
        5702,
        5703
    ],
    "tidung, northern": [
        5710
    ],
    "theithei": [
        5711
    ],
    "tepehuan, northern": [
        5718
    ],
    "tepehuan": [
        5718,
        7173,
        7560
    ],
    "tepehuán del norte": [
        5718
    ],
    "tepehuán": [
        5718,
        7173,
        7560
    ],
    "tangkhul naga (myanmar)": [
        5722
    ],
    "thuanga": [
        5725
    ],
    "tsu": [
        5729
    ],
    "t’aat’aaqsapa": [
        5734
    ],
    "tasman": [
        5741
    ],
    "thok nath": [
        5743,
        5744
    ],
    "tai nung": [
        5745
    ],
    "tày nùng": [
        5745
    ],
    "tày": [
        7871,
        7872,
        7873,
        7878,
        5745,
        7672
    ],
    "tlamacazapa": [
        5751
    ],
    "tlamacazapa nahuatl": [
        5751
    ],
    "tanna, southwest": [
        5765
    ],
    "tanna": [
        5765,
        7625,
        7623,
        7622
    ],
    "tedi": [
        5784
    ],
    "tidi": [
        5784
    ],
    "tutrugbu": [
        5788
    ],
    "teta": [
        5807
    ],
    "tete": [
        5807
    ],
    "tigon": [
        5812
    ],
    "tigon mbembe": [
        5812
    ],
    "tigong": [
        5812
    ],
    "tigum": [
        5812
    ],
    "tigun": [
        5812
    ],
    "tikun": [
        5812
    ],
    "tukun": [
        5812
    ],
    "teke-nzikou": [
        5819
    ],
    "tlahuica": [
        5839
    ],
    "tlahura": [
        5839
    ],
    "th-th": [
        5882
    ],
    "tairora, south": [
        5917
    ],
    "tairora": [
        5917,
        7334
    ],
    "tohono o’odham": [
        5937
    ],
    "tohono": [
        5937
    ],
    "tohono o'odham": [
        5937
    ],
    "tohono o’otham": [
        5937
    ],
    "teguima": [
        5946
    ],
    "tutapi": [
        5952
    ],
    "tribal oriya": [
        5959
    ],
    "tribal": [
        5959
    ],
    "towati": [
        5962
    ],
    "tilapa": [
        5986
    ],
    "tilapa otomi": [
        5986
    ],
    "tenango otomi": [
        5988
    ],
    "temoaya": [
        5992
    ],
    "temoaya otomi": [
        5992
    ],
    "toluca otomi": [
        5992
    ],
    "toluca": [
        5992
    ],
    "texcatepec": [
        5995
    ],
    "texcatepec otomi": [
        5995
    ],
    "tamil": [
        7296,
        7297,
        7298,
        7299,
        7300,
        5996,
        6067
    ],
    "tagargrent": [
        5998
    ],
    "taina": [
        6005
    ],
    "thae": [
        6007
    ],
    "tupi do machado": [
        6022
    ],
    "tupí-kawahíb": [
        6022
    ],
    "tenharim": [
        6025
    ],
    "tenharem": [
        6025
    ],
    "tenharin": [
        6025
    ],
    "timbisha": [
        6035
    ],
    "tumpisa shoshone": [
        6035
    ],
    "tumpisa": [
        6035
    ],
    "tümpisa panamint shoshone": [
        6035
    ],
    "tümpisa": [
        6035
    ],
    "tümpisa shoshone": [
        6035
    ],
    "tümpisa shoshoni": [
        6035
    ],
    "tekoi ra belau": [
        6037
    ],
    "tekoi": [
        6037
    ],
    "trong ggia": [
        6062,
        6063
    ],
    "trong": [
        6062,
        6063
    ],
    "tu-dìn": [
        6062,
        6063
    ],
    "tujia": [
        7522,
        7529,
        6062,
        6063
    ],
    "ta’ang": [
        6191,
        6486,
        6065
    ],
    "ta-ang": [
        6066,
        6191
    ],
    "tagara": [
        6072,
        6073
    ],
    "thakara": [
        6072,
        6073
    ],
    "tugara": [
        6072,
        6073
    ],
    "takankar": [
        6076
    ],
    "takia": [
        7330,
        6076
    ],
    "taje": [
        6092
    ],
    "thundai-kanza": [
        6102
    ],
    "tisman": [
        6115
    ],
    "then": [
        7372,
        6121
    ],
    "tóng": [
        6121
    ],
    "tai phake": [
        6125
    ],
    "tokanï": [
        6143
    ],
    "tokani": [
        6143
    ],
    "tokanu": [
        6143
    ],
    "thiwene": [
        6145
    ],
    "tjalkadjara": [
        6150
    ],
    "tjubun": [
        6150
    ],
    "tjupan": [
        6150,
        7528
    ],
    "tsáçe": [
        6155
    ],
    "tong-pak": [
        6170
    ],
    "te leo wale": [
        6175
    ],
    "tani": [
        6182,
        7620
    ],
    "ta-ang palaung": [
        6191
    ],
    "ta’ang samlung": [
        6191
    ],
    "tlacoyalco": [
        6197
    ],
    "tlalcoyalco": [
        6197
    ],
    "tuamotuan": [
        6219
    ],
    "tapango": [
        6225
    ],
    "ta̱rin": [
        6228
    ],
    "tarin": [
        6228
    ],
    "tə-rĩ": [
        6228
    ],
    "tongareva": [
        6229
    ],
    "trabzon": [
        6241,
        6242,
        6243
    ],
    "trapezountiac": [
        6241,
        6242,
        6243
    ],
    "tofoke": [
        6252
    ],
    "topoke": [
        6252
    ],
    "tovoke": [
        6252
    ],
    "tactic pokomchí": [
        6254
    ],
    "tactic": [
        6254
    ],
    "texistepec": [
        6261
    ],
    "texistepec popoluca": [
        6261
    ],
    "temalacayuca": [
        6277
    ],
    "telikóng": [
        6298
    ],
    "to pamosean": [
        6317
    ],
    "to panasean": [
        6317
    ],
    "tavytera": [
        6341
    ],
    "tavyterã": [
        6341
    ],
    "tupí of cuminapanema": [
        6345
    ],
    "tupí": [
        7679,
        6345,
        8896
    ],
    "tehuelche": [
        7416,
        6358
    ],
    "tudahwe": [
        6374
    ],
    "tamari": [
        6379,
        7354
    ],
    "talaing karen": [
        6380
    ],
    "tipun": [
        6388,
        6389
    ],
    "tujaal tziij": [
        6411
    ],
    "tujaal": [
        6411
    ],
    "tziij": [
        6411
    ],
    "tena lowland quichua": [
        6412
    ],
    "tarma quechua": [
        6423
    ],
    "tarma": [
        6423
    ],
    "tarma-junín quechua": [
        6423
    ],
    "tarma-junín": [
        6423
    ],
    "tigre quechua": [
        6429
    ],
    "tigre": [
        6429,
        7499,
        7500,
        7501
    ],
    "tungurahua highland quichua": [
        6439
    ],
    "tungurahua": [
        6439
    ],
    "tungurahua quichua": [
        6439
    ],
    "tusi": [
        6446
    ],
    "tulu-bohuai": [
        6465
    ],
    "te reo maori": [
        6472
    ],
    "tegali": [
        6473
    ],
    "tagale": [
        6473
    ],
    "tegele": [
        6473
    ],
    "tekele": [
        6473
    ],
    "togole": [
        6473
    ],
    "turjok": [
        6473
    ],
    "tangsarr": [
        6481,
        6482
    ],
    "tai rumai": [
        6486
    ],
    "ta’ang rumai": [
        6486
    ],
    "tsureshe": [
        6503
    ],
    "tsureja": [
        6503
    ],
    "tipra": [
        6517,
        7662,
        7663
    ],
    "tarifit": [
        6519,
        6520,
        6521,
        6522
    ],
    "tamazight n arrif": [
        6519,
        6520,
        6521,
        6522
    ],
    "tarifiyt": [
        6519,
        6520,
        6521,
        6522
    ],
    "tarifyt berber": [
        6519,
        6520,
        6521,
        6522
    ],
    "tarifyt": [
        6519,
        6520,
        6521,
        6522
    ],
    "tirifie": [
        6519,
        6520,
        6521,
        6522
    ],
    "tmazight": [
        6519,
        6520,
        6521,
        6522,
        7884,
        7885,
        7886
    ],
    "tmaziɣt": [
        6519,
        6520,
        6521,
        6522,
        7884,
        7885,
        7886
    ],
    "tajpuria": [
        6531
    ],
    "tugurimba": [
        6538
    ],
    "traveller danish": [
        6543
    ],
    "traveller": [
        6543,
        7710,
        6546,
        6561
    ],
    "tšibbaha": [
        6545
    ],
    "traveller norwegian": [
        6546
    ],
    "tsigane": [
        6556
    ],
    "tsigene": [
        6560,
        6588,
        6590
    ],
    "tavringer": [
        6561
    ],
    "tavringer romani": [
        6561
    ],
    "traveller swedish": [
        6561
    ],
    "tae’": [
        6581,
        6747
    ],
    "tae'": [
        6581
    ],
    "taeq": [
        6581,
        6747
    ],
    "tae’ tae’": [
        6581
    ],
    "toala’": [
        6581
    ],
    "toraja timur": [
        6581
    ],
    "toware": [
        6581
    ],
    "toshiyabe": [
        6583
    ],
    "torogo": [
        6583
    ],
    "tiyad ini": [
        6587
    ],
    "tiyad": [
        6587
    ],
    "tsingani": [
        6588,
        6590
    ],
    "tent gypsy": [
        6601
    ],
    "tent": [
        6601
    ],
    "tajik sign language": [
        6603
    ],
    "tajik": [
        7442,
        7443,
        7444,
        7445,
        6603,
        7108
    ],
    "taungtha": [
        6605
    ],
    "toratan": [
        6606
    ],
    "toratán": [
        6606
    ],
    "tenggalan": [
        6708
    ],
    "tingalan": [
        6708
    ],
    "tingalun": [
        6708
    ],
    "tinggalan": [
        6708
    ],
    "tinggalum": [
        6708
    ],
    "tod": [
        6711,
        6712
    ],
    "tod-kad": [
        6711,
        6712
    ],
    "ta sara": [
        6717
    ],
    "tunghsiang": [
        6720,
        6721
    ],
    "tam": [
        6732,
        7279,
        7390,
        7391,
        7599
    ],
    "tiseni": [
        6738
    ],
    "toraja-sa’dan": [
        6747
    ],
    "toraya": [
        6747
    ],
    "tora’a": [
        6747
    ],
    "toradja": [
        6747
    ],
    "toraja-sa'dan": [
        6747
    ],
    "tivori": [
        6750
    ],
    "tebakang": [
        6759
    ],
    "tang": [
        6777
    ],
    "tiebaara": [
        6779
    ],
    "tyebala": [
        6779
    ],
    "tsek’ehne": [
        6784,
        6785
    ],
    "tsek’ene": [
        6784,
        6785
    ],
    "tsek’hene": [
        6784,
        6785
    ],
    "tse’khene": [
        6784,
        6785
    ],
    "tagba": [
        6789,
        7341
    ],
    "tshumakwe": [
        6835
    ],
    "ta̲i̲kwappe": [
        6836
    ],
    "tachelhit": [
        6837,
        6838,
        6839,
        7884,
        7885,
        7886
    ],
    "tachelheit": [
        6837,
        6838,
        6839
    ],
    "tachilhit": [
        6837,
        6838,
        6839
    ],
    "tashelhait": [
        6837,
        6838,
        6839
    ],
    "tashelhayt": [
        6837,
        6838,
        6839
    ],
    "tashelheit": [
        6837,
        6838,
        6839
    ],
    "tashelheyt": [
        6837,
        6838,
        6839
    ],
    "tashelhit": [
        6837,
        6838,
        6839
    ],
    "tashilheet": [
        6837,
        6838,
        6839
    ],
    "tashlhiyt": [
        6837,
        6838,
        6839
    ],
    "tasoussit": [
        6837,
        6838,
        6839
    ],
    "tašlḥiyt": [
        6837,
        6838,
        6839
    ],
    "tashelḥiyt": [
        6839
    ],
    "tai long": [
        7474,
        6845,
        6846,
        6847,
        6848
    ],
    "tai luang": [
        6845,
        6846,
        6847,
        6848
    ],
    "tai shan": [
        6845,
        6846,
        6847,
        6848
    ],
    "tai yai": [
        6845,
        6846,
        6847,
        6848
    ],
    "tai yay": [
        6845,
        6846,
        6847,
        6848
    ],
    "tai-lon": [
        6845,
        6846,
        6847,
        6848
    ],
    "thai yai": [
        6845,
        6846,
        6847,
        6848
    ],
    "thai yay": [
        6845,
        6846,
        6847,
        6848
    ],
    "tai mau": [
        6846
    ],
    "tchad": [
        6856,
        6855
    ],
    "tachawit": [
        6860,
        6861,
        6862
    ],
    "tacawit": [
        6860,
        6861,
        6862
    ],
    "tshikiana": [
        6876
    ],
    "tumulung": [
        6877
    ],
    "tumulung sisaala": [
        6877
    ],
    "togoba": [
        6884
    ],
    "tajeblit": [
        6906
    ],
    "tamazight n jbala": [
        6906
    ],
    "tasenhajit": [
        6906
    ],
    "ter": [
        6907
    ],
    "ter sami": [
        6907
    ],
    "tulalip": [
        6912
    ],
    "tai sek": [
        6913
    ],
    "talatui": [
        6915
    ],
    "talutui": [
        6915
    ],
    "turutap": [
        6931
    ],
    "te mawo": [
        6934
    ],
    "tumawo": [
        6934
    ],
    "twulshootseed": [
        6946
    ],
    "tayatuk": [
        6965
    ],
    "tsaam": [
        6986
    ],
    "tenti": [
        6998
    ],
    "thai song": [
        7023,
        7024
    ],
    "tai song dam": [
        7023,
        7024
    ],
    "thai soang": [
        7023,
        7024
    ],
    "toros": [
        7037
    ],
    "tsong": [
        7038
    ],
    "thai, southern": [
        7043
    ],
    "temi": [
        7048
    ],
    "tamilouw": [
        7049
    ],
    "tosk": [
        7068,
        7070,
        7071
    ],
    "tushama": [
        7075
    ],
    "tadzik": [
        7108
    ],
    "tawau murut": [
        7110
    ],
    "tawau": [
        7110
    ],
    "tawou murut": [
        7110
    ],
    "tawou": [
        7110
    ],
    "tsuu t’ina": [
        7118
    ],
    "tsuu": [
        7118
    ],
    "t’ina": [
        7118
    ],
    "tsúùtínà": [
        7118
    ],
    "tekela": [
        7127
    ],
    "tekeza": [
        7127
    ],
    "thithiza": [
        7127
    ],
    "tawi-tawi": [
        7129
    ],
    "tawi-tawi sinama": [
        7129
    ],
    "thao": [
        7134
    ],
    "thaw a lalawa": [
        7134
    ],
    "thaw": [
        7134
    ],
    "thebarshad": [
        7139
    ],
    "thro": [
        7147,
        7148
    ],
    "tuboy subanon": [
        7159
    ],
    "tuboy": [
        7159
    ],
    "teula": [
        7161
    ],
    "trieng": [
        7163,
        7389
    ],
    "ta-rieng": [
        7163
    ],
    "talieng": [
        7389,
        7163
    ],
    "tareh": [
        7163
    ],
    "treng": [
        7163
    ],
    "traveler": [
        7164
    ],
    "tarri": [
        7164
    ],
    "the cant": [
        7164
    ],
    "tinker’s cant": [
        7164
    ],
    "tinker’s": [
        7164
    ],
    "the ould thing": [
        7164
    ],
    "thing": [
        7164
    ],
    "tougan": [
        7167
    ],
    "tepehuan, southeastern": [
        7173
    ],
    "tepehuano": [
        7173
    ],
    "tepehuán del sureste": [
        7173
    ],
    "tirmaga-chai": [
        7196,
        7197
    ],
    "tirmaga-chai suri": [
        7196,
        7197
    ],
    "tasuknit": [
        7241
    ],
    "tchevi": [
        7244
    ],
    "tanglapui": [
        7247,
        7665
    ],
    "tanlapui": [
        7247
    ],
    "toewawa": [
        7248
    ],
    "tuwawa": [
        7248
    ],
    "tsaphe": [
        7265
    ],
    "tsaphe -gbe": [
        7265
    ],
    "tsáphɛ": [
        7265
    ],
    "taar shamyan": [
        7278
    ],
    "tamal": [
        7296,
        7297
    ],
    "tamalsan": [
        7296,
        7297
    ],
    "tambul": [
        7296,
        7297
    ],
    "tamili": [
        7296,
        7297
    ],
    "tanana, lower": [
        7301
    ],
    "tanana": [
        7301,
        7320
    ],
    "tanana athabaskan": [
        7301
    ],
    "tabasaran": [
        7302
    ],
    "tabasarantsky": [
        7302
    ],
    "tabassaran": [
        7302
    ],
    "tarahumara, western": [
        7303
    ],
    "tarahumara": [
        7303,
        7318,
        7373,
        7473,
        7833
    ],
    "tarahumara del oeste": [
        7303
    ],
    "tarahumara del poniente": [
        7303
    ],
    "tause": [
        7304
    ],
    "tariana": [
        7305
    ],
    "taliáseri": [
        7305
    ],
    "tariano": [
        7305
    ],
    "tariána": [
        7305
    ],
    "tariáno": [
        7305
    ],
    "tarîna": [
        7305
    ],
    "tapirapé": [
        7306
    ],
    "tapi’irape": [
        7306
    ],
    "tagoi": [
        7307
    ],
    "tagoy": [
        7307
    ],
    "tamang, eastern": [
        7308,
        7309,
        7310
    ],
    "tamang": [
        7308,
        7309,
        7310,
        7390,
        7391,
        7450,
        7599
    ],
    "tal": [
        7312,
        7376,
        7377
    ],
    "tal mwa": [
        7312
    ],
    "tangale": [
        7313
    ],
    "tangle": [
        7313
    ],
    "tabago": [
        7314
    ],
    "tao": [
        7314
    ],
    "tawu": [
        7314
    ],
    "taabwa": [
        7315
    ],
    "taabua": [
        7315
    ],
    "tabwa": [
        7315
    ],
    "tamasheq": [
        7316,
        7317,
        7486,
        7487,
        7488,
        7489,
        7594,
        7595,
        7596
    ],
    "tǝmajǝq": [
        7316,
        7317
    ],
    "tamachen": [
        7316,
        7317
    ],
    "tamashek": [
        7594,
        7316,
        7317,
        7595,
        7596
    ],
    "tamashekin": [
        7316,
        7317,
        7486,
        7487,
        7488,
        7489,
        7594,
        7595,
        7596
    ],
    "tamasheq, kidal": [
        7316,
        7317
    ],
    "tomacheck": [
        7316,
        7317,
        7491,
        7492,
        7594,
        7595,
        7596
    ],
    "tamachèque": [
        7316,
        7317
    ],
    "tamasagt": [
        7316,
        7317
    ],
    "tarahumara, central": [
        7318
    ],
    "tarahumara de cumbres": [
        7318
    ],
    "tarahumara del centro": [
        7318
    ],
    "tay boi": [
        7319
    ],
    "tay boy": [
        7319
    ],
    "tanana, upper": [
        7320
    ],
    "tabesna": [
        7320
    ],
    "tatuyo": [
        7321
    ],
    "tatuyo ye": [
        7321
    ],
    "tatutapuyo": [
        7321
    ],
    "tai mnm": [
        7322
    ],
    "tay mnm": [
        7322
    ],
    "tamki": [
        7323
    ],
    "temki": [
        7323
    ],
    "taijyal": [
        7324,
        7325,
        7326
    ],
    "taiyal": [
        7324,
        7325,
        7326
    ],
    "takonan": [
        7324,
        7325,
        7326
    ],
    "tangao": [
        7324,
        7325,
        7326
    ],
    "tayal": [
        7324,
        7325,
        7326
    ],
    "tyal": [
        7324,
        7325,
        7326
    ],
    "tocho": [
        7327
    ],
    "tacho": [
        7327
    ],
    "toicho": [
        7327
    ],
    "tubarão": [
        7328
    ],
    "tapeba": [
        7329
    ],
    "tate": [
        7331
    ],
    "tanibili": [
        7332
    ],
    "tanimbili": [
        7332
    ],
    "tairora, north": [
        7334
    ],
    "thurawal": [
        7335
    ],
    "turrubul": [
        7335,
        8956
    ],
    "tabi": [
        7336,
        7624
    ],
    "tiang": [
        7337
    ],
    "tiaang": [
        7337
    ],
    "tagbanwa, calamian": [
        7338,
        7339
    ],
    "tagbanwa": [
        7338,
        7339,
        7350,
        7351,
        7461
    ],
    "tinagbanwa": [
        7339,
        7338
    ],
    "tboli": [
        7340
    ],
    "tiboli": [
        7340
    ],
    "t’boli": [
        7340
    ],
    "tagbu": [
        7341
    ],
    "tunebo, barro negro": [
        7342
    ],
    "tunebo": [
        7342,
        7616,
        7618,
        7788
    ],
    "tawala": [
        7343,
        7827
    ],
    "tavara": [
        7343,
        7827
    ],
    "tawara": [
        7827,
        7343
    ],
    "taburta": [
        7344
    ],
    "taria": [
        7344
    ],
    "taworta": [
        7344
    ],
    "taworta-aero": [
        7344
    ],
    "tumtum": [
        7345
    ],
    "tanguat": [
        7346
    ],
    "tembo": [
        7347,
        7609
    ],
    "tembo (kitembo)": [
        7347
    ],
    "tubar": [
        7348
    ],
    "tubare": [
        7348,
        7833
    ],
    "tobo": [
        7349
    ],
    "tagbanua": [
        7350,
        7351
    ],
    "taiak": [
        7352
    ],
    "tayek": [
        7352
    ],
    "tabaru": [
        7353
    ],
    "tobaru": [
        7353
    ],
    "tamberma": [
        7354
    ],
    "ticuna": [
        7355
    ],
    "ticunagaxũ": [
        7355
    ],
    "tikuna": [
        7355
    ],
    "tucuna": [
        7355
    ],
    "tukuna": [
        7355
    ],
    "tukúna": [
        7355
    ],
    "tanacross": [
        7356
    ],
    "tatog": [
        7357
    ],
    "tatoga": [
        7357
    ],
    "taturu": [
        7357
    ],
    "tafi": [
        7358
    ],
    "tegbo": [
        7358
    ],
    "tutchone, southern": [
        7359
    ],
    "tutchone": [
        7359,
        7767
    ],
    "tutchone du sud": [
        7359
    ],
    "tlapanec": [
        7360,
        7661,
        7669,
        7680
    ],
    "tlapaneco": [
        7360,
        7661,
        7669,
        7680
    ],
    "tlapaneco central bajo": [
        7360
    ],
    "tlapaneco de malinaltepec": [
        7360
    ],
    "tlapaneko": [
        7360
    ],
    "tamagario": [
        7361
    ],
    "tamaraw": [
        7361
    ],
    "turks and caicos english creole": [
        7362
    ],
    "turks and caicos creole english": [
        7362
    ],
    "tjokwai": [
        7363
    ],
    "tokwasa": [
        7363
    ],
    "tchitchege": [
        7364
    ],
    "taman (myanmar)": [
        7365
    ],
    "tanahmerah": [
        7366,
        7624
    ],
    "tichurong": [
        7367
    ],
    "ticherong": [
        7367
    ],
    "taungyo": [
        7368
    ],
    "taung yoe": [
        7368
    ],
    "taung-yo": [
        7368
    ],
    "toru": [
        7368
    ],
    "twing reu": [
        7368
    ],
    "twing": [
        7368
    ],
    "twinreu": [
        7368
    ],
    "tawr": [
        7369
    ],
    "tawr chin": [
        7369
    ],
    "thawr": [
        7369
    ],
    "thor": [
        7369
    ],
    "thor chin": [
        7369
    ],
    "torr": [
        7369
    ],
    "taori-kaiy": [
        7370
    ],
    "taori-kei": [
        7370
    ],
    "todi": [
        7370,
        7375
    ],
    "torres strait creole": [
        7371
    ],
    "tok": [
        7666,
        8242,
        7371
    ],
    "thap": [
        7371
    ],
    "tores streit yumplatok": [
        7371
    ],
    "tores": [
        7371
    ],
    "torres strait broken": [
        7371
    ],
    "torres strait pidgin english": [
        7371
    ],
    "t’en": [
        7372
    ],
    "t'en": [
        7372
    ],
    "tarahumara, southeastern": [
        7373
    ],
    "tarahumara de chinatú": [
        7373
    ],
    "tarahumara del sur": [
        7373
    ],
    "tarahumara del sureste": [
        7373
    ],
    "totonac, tecpatlán": [
        7374
    ],
    "totonac": [
        7374,
        7551,
        7562,
        7576,
        7640,
        7649,
        7650,
        7653,
        7691
    ],
    "tecpatlán": [
        7374
    ],
    "tecpatlán totonac": [
        7374
    ],
    "totonaca": [
        7551,
        7374,
        7649,
        7650
    ],
    "toda": [
        7375,
        7722,
        7797
    ],
    "tuda": [
        7375,
        7797
    ],
    "tulu": [
        7376,
        7377
    ],
    "tallu": [
        7376,
        7377
    ],
    "thalu": [
        7376,
        7377
    ],
    "thulu": [
        7376,
        7377,
        7392
    ],
    "tilu": [
        7376,
        7377
    ],
    "tullu": [
        7376,
        7377
    ],
    "tuluva bhasa": [
        7376,
        7377
    ],
    "tuluva": [
        7376,
        7377
    ],
    "thado": [
        7378
    ],
    "thaadou": [
        7378
    ],
    "thaadou kuki": [
        7378
    ],
    "thaadow": [
        7378
    ],
    "thado chin": [
        7378
    ],
    "thado-pao": [
        7378
    ],
    "thado-ubiphei": [
        7378
    ],
    "thadou": [
        7378
    ],
    "thadou kuki": [
        7378
    ],
    "thadou pao": [
        7378
    ],
    "thadow": [
        7378
    ],
    "tagdal": [
        7379,
        7380,
        7381
    ],
    "tair": [
        7382,
        7383,
        7384
    ],
    "tamara": [
        7382,
        7383,
        7384
    ],
    "tamaria": [
        7382,
        7383,
        7384
    ],
    "tanti": [
        7382,
        7383,
        7384
    ],
    "temoral": [
        7382,
        7383,
        7384
    ],
    "tumariya": [
        7382,
        7383,
        7384
    ],
    "tai nüa": [
        7386,
        7387
    ],
    "tai dehong": [
        7386,
        7387
    ],
    "tai kong": [
        7386,
        7387
    ],
    "tai le": [
        7386,
        7387
    ],
    "tai mao": [
        7386,
        7387
    ],
    "tai neua": [
        7386,
        7387
    ],
    "tai nue": [
        7386,
        7387
    ],
    "tai nuea": [
        7386,
        7387
    ],
    "tai nü": [
        7386,
        7387
    ],
    "tai nö": [
        7386,
        7387
    ],
    "tai taü": [
        7386,
        7387
    ],
    "taü": [
        7386,
        7387
    ],
    "tai-kong": [
        7386,
        7387
    ],
    "tai-le": [
        7386,
        7387
    ],
    "thaineau": [
        7386,
        7387
    ],
    "tiranige": [
        7388
    ],
    "tiranige diga dogon": [
        7388
    ],
    "taliang": [
        7389
    ],
    "tariang": [
        7389,
        7459
    ],
    "tarieng": [
        7389
    ],
    "triang": [
        7389
    ],
    "tamang, western": [
        7390,
        7391
    ],
    "tamang gyot": [
        7390,
        7391,
        7599
    ],
    "tamang tam": [
        7390,
        7391,
        7599
    ],
    "thulung": [
        7392
    ],
    "tholong lo": [
        7392
    ],
    "tholong": [
        7392
    ],
    "thulu luwa": [
        7392
    ],
    "thululoa": [
        7392
    ],
    "thulung jemu": [
        7392
    ],
    "thulung la": [
        7392
    ],
    "thulunge rai": [
        7392
    ],
    "thulunge": [
        7392
    ],
    "toaku lwa": [
        7392
    ],
    "toaku": [
        7392
    ],
    "tomadino": [
        7393
    ],
    "tajio": [
        7394
    ],
    "tadjio": [
        7394
    ],
    "ta’adjio": [
        7394
    ],
    "tambas": [
        7395
    ],
    "tambes": [
        7395
    ],
    "tembis": [
        7395
    ],
    "tapshin": [
        7396
    ],
    "tapshinawa": [
        7396
    ],
    "taruma": [
        7397
    ],
    "taruamá": [
        7397
    ],
    "tondano": [
        7398
    ],
    "tolou": [
        7398
    ],
    "tolour": [
        7398
    ],
    "tondanou": [
        7398
    ],
    "toulour": [
        7398
    ],
    "toundano": [
        7398
    ],
    "teme": [
        7399
    ],
    "tema": [
        7399
    ],
    "todrah": [
        7401
    ],
    "todrá": [
        7401
    ],
    "taori": [
        7402
    ],
    "taori-so": [
        7402
    ],
    "tolitai": [
        7402
    ],
    "tetun dili": [
        7403
    ],
    "tetun": [
        7403,
        7427
    ],
    "tetum": [
        7427,
        7403
    ],
    "tetum dili": [
        7403
    ],
    "tetum prasa": [
        7403
    ],
    "tetum praça": [
        7403
    ],
    "tetun prasa": [
        7403
    ],
    "turkwam": [
        7404
    ],
    "tandroy-mahafaly": [
        7405
    ],
    "tandroy": [
        7405
    ],
    "tandroy-mahafaly malagasy": [
        7405
    ],
    "tadyawan": [
        7406
    ],
    "tadianan": [
        7406
    ],
    "telugu": [
        7407,
        7408,
        8343,
        8344,
        8345,
        8346
    ],
    "tailangi": [
        7407,
        7408
    ],
    "telangire": [
        7407,
        7408
    ],
    "telegu": [
        7407,
        7408
    ],
    "telgi": [
        7407,
        7408
    ],
    "telinga": [
        7407,
        7408
    ],
    "teloogoo": [
        7407,
        7408
    ],
    "telungu": [
        7407,
        7408
    ],
    "tenungu": [
        7407,
        7408
    ],
    "terangi": [
        7407,
        7408
    ],
    "tolangan": [
        7407,
        7408
    ],
    "trilinga": [
        7407,
        7408
    ],
    "temiar": [
        7409
    ],
    "temèèr": [
        7409
    ],
    "temer": [
        7409
    ],
    "tetete": [
        7410
    ],
    "terik": [
        7411,
        7427
    ],
    "tepo": [
        7412
    ],
    "tépo": [
        7412
    ],
    "tepo krou": [
        7412
    ],
    "tepo krumen": [
        7412
    ],
    "tepehua, huehuetla": [
        7413
    ],
    "tepehua": [
        7413,
        7673,
        7676
    ],
    "tepehua de hidalgo": [
        7413
    ],
    "tepehua de huehuetla": [
        7413
    ],
    "teressa": [
        7414
    ],
    "taih-long": [
        7414
    ],
    "teke-tege": [
        7415
    ],
    "tege-kali": [
        7415
    ],
    "teghe": [
        7415
    ],
    "teke alima": [
        7415
    ],
    "teke kali": [
        7415
    ],
    "tewelche": [
        7416
    ],
    "torricelli": [
        7417
    ],
    "teke, ibali": [
        7418
    ],
    "teke-ibali": [
        7418
    ],
    "themne": [
        7419
    ],
    "temen": [
        7419
    ],
    "timene": [
        7419
    ],
    "timmannee": [
        7419
    ],
    "timne": [
        7419
    ],
    "tama (colombia)": [
        7420
    ],
    "teso": [
        7421,
        7422
    ],
    "tepecano": [
        7423
    ],
    "temein": [
        7424
    ],
    "temainian": [
        7424
    ],
    "terêna": [
        7425
    ],
    "tereno": [
        7425
    ],
    "tengger": [
        7426
    ],
    "tenggerese": [
        7426
    ],
    "teto": [
        7427
    ],
    "tettum": [
        7427
    ],
    "tetu": [
        7427
    ],
    "tetun belu": [
        7427
    ],
    "tetun terik": [
        7427
    ],
    "tetung": [
        7427
    ],
    "toongi": [
        7428
    ],
    "teor": [
        7429
    ],
    "tio’or": [
        7429
    ],
    "tewa": [
        7430,
        7431,
        7432,
        7822
    ],
    "tano": [
        7430,
        7431,
        7432
    ],
    "tewa (usa)": [
        7430
    ],
    "tewa - santa clara": [
        7431
    ],
    "tewa - san juan": [
        7432
    ],
    "tennet": [
        7433
    ],
    "tennette": [
        7433
    ],
    "tenet": [
        7433
    ],
    "tulishi": [
        7434
    ],
    "thulishi": [
        7434
    ],
    "tulesh": [
        7434
    ],
    "tetserret": [
        7435,
        7436
    ],
    "tin sert": [
        7435,
        7436
    ],
    "tofin": [
        7437
    ],
    "tofi": [
        7437
    ],
    "tofin gbe": [
        7437
    ],
    "tofingbe": [
        7437
    ],
    "tɔfin": [
        7437
    ],
    "tɔfingbe": [
        7437
    ],
    "tanaina": [
        7438
    ],
    "tefaro": [
        7439
    ],
    "teribe": [
        7440
    ],
    "terraba": [
        7440
    ],
    "tiribi": [
        7440
    ],
    "tirribi": [
        7440
    ],
    "tadzhik": [
        7442,
        7443,
        7445
    ],
    "tajiki persian": [
        7442,
        7443,
        7445
    ],
    "teri": [
        7446
    ],
    "tobilung": [
        7447
    ],
    "tabilong": [
        7447
    ],
    "tebilung": [
        7447
    ],
    "tobilang": [
        7447
    ],
    "tigak": [
        7448
    ],
    "tsaganci": [
        7449
    ],
    "tamang, eastern gorkha": [
        7450
    ],
    "tshali": [
        7451
    ],
    "tshalingpa": [
        7451,
        7738
    ],
    "tobagonian english creole": [
        7452
    ],
    "tobagonian": [
        7452
    ],
    "tobagonian creole english": [
        7452
    ],
    "tobagonian dialect": [
        7452
    ],
    "tagin": [
        7454
    ],
    "tandaganon": [
        7455
    ],
    "tagon-on": [
        7455
    ],
    "tagula": [
        7456
    ],
    "tangoa": [
        7457
    ],
    "tring": [
        7458
    ],
    "tareng": [
        7459
    ],
    "tarasag": [
        7460
    ],
    "tagbanwa, central": [
        7461
    ],
    "tanggu": [
        7462
    ],
    "tanggu-nai": [
        7462
    ],
    "tanggum": [
        7462
    ],
    "tangu": [
        7462
    ],
    "tingui-boto": [
        7463
    ],
    "tingui": [
        7463
    ],
    "tingui botó": [
        7463
    ],
    "tagwana": [
        7464
    ],
    "tagbana": [
        7464
    ],
    "tagouna": [
        7464
    ],
    "tagwana senoufo": [
        7464
    ],
    "tagish": [
        7465
    ],
    "togoyo": [
        7466
    ],
    "togoy": [
        7466
    ],
    "tagalaka": [
        7467
    ],
    "tagalag": [
        7467
    ],
    "takalak": [
        7467
    ],
    "targa-lag": [
        7467
    ],
    "tarkalag": [
        7467
    ],
    "thai klang": [
        7468,
        7469
    ],
    "thaiklang": [
        7468,
        7469
    ],
    "thayorre": [
        7470
    ],
    "thaayoore": [
        7470
    ],
    "thaayorre": [
        7470
    ],
    "taior": [
        7470
    ],
    "thaayore": [
        7470
    ],
    "thayore": [
        7470
    ],
    "tharu, central": [
        7471
    ],
    "tharu": [
        7471,
        7476,
        7481,
        7482,
        7550
    ],
    "tharu, chitwania": [
        7471
    ],
    "thangmi": [
        7472
    ],
    "thami": [
        7472
    ],
    "thangmi kham": [
        7472
    ],
    "thangmi wakhe": [
        7472
    ],
    "thani": [
        7472
    ],
    "tarahumara, northern": [
        7473
    ],
    "tarahumara del norte": [
        7473
    ],
    "tharaka": [
        7475
    ],
    "tharu, dangaura": [
        7476
    ],
    "thavung": [
        7477
    ],
    "thachanadan": [
        7478
    ],
    "thacchanadens": [
        7478
    ],
    "thachanad muppans": [
        7478
    ],
    "thachanad": [
        7478
    ],
    "thompson": [
        7479,
        7480
    ],
    "thompson salish": [
        7479,
        7480
    ],
    "tharu, mid-eastern": [
        7481
    ],
    "tharu, kochila": [
        7481
    ],
    "tharu, rana": [
        7482
    ],
    "thakur": [
        7482
    ],
    "tharuwa": [
        7482
    ],
    "thakali": [
        7483
    ],
    "tapaang": [
        7483
    ],
    "thaksya": [
        7483
    ],
    "tahltan": [
        7484
    ],
    "tāltān": [
        7484
    ],
    "thuri": [
        7485
    ],
    "tamahaq, tahaggart": [
        7486,
        7487,
        7488,
        7489
    ],
    "tamahaq": [
        7486,
        7487,
        7488,
        7489
    ],
    "tahaggart": [
        7486,
        7487,
        7488,
        7489
    ],
    "tahaggart tamahaq": [
        7486,
        7487,
        7488,
        7489
    ],
    "tamachek": [
        7486,
        7487,
        7488,
        7489,
        7491,
        7492,
        7594,
        7595,
        7596
    ],
    "tamachek’": [
        7486,
        7487,
        7488,
        7489
    ],
    "tomachek": [
        7486,
        7487,
        7488,
        7489
    ],
    "touareg": [
        7486,
        7487,
        7488,
        7489,
        7491,
        7492,
        7594,
        7595,
        7596
    ],
    "tourage": [
        7486,
        7487,
        7488,
        7489,
        7594,
        7595,
        7596
    ],
    "toureg": [
        7486,
        7487,
        7489
    ],
    "tuareg": [
        7486,
        7487,
        7488,
        7489,
        7491,
        7492,
        7594,
        7595,
        7596
    ],
    "tha": [
        7490
    ],
    "tamajeq, tayart": [
        7491,
        7492
    ],
    "tamajeq": [
        7491,
        7492,
        7594,
        7595,
        7596
    ],
    "tayart": [
        7491,
        7492
    ],
    "tayart tamajeq": [
        7491,
        7492
    ],
    "tigrigna": [
        7493,
        7494,
        7495
    ],
    "tigray": [
        7495
    ],
    "tigrinya": [
        7495
    ],
    "tamazight, tidikelt": [
        7496
    ],
    "tidikelt": [
        7496
    ],
    "tidikelt tamazight": [
        7496
    ],
    "tira": [
        7497
    ],
    "thiro": [
        7497
    ],
    "tifal": [
        7498
    ],
    "tifalmin": [
        7498
    ],
    "tigré": [
        7499,
        7500,
        7501
    ],
    "timugon": [
        7502
    ],
    "temogun": [
        7502
    ],
    "timigan": [
        7502
    ],
    "timigun": [
        7502
    ],
    "timogon": [
        7502
    ],
    "timogun": [
        7502
    ],
    "timugon murut": [
        7502
    ],
    "tumugun": [
        7502
    ],
    "tiene": [
        7503
    ],
    "tende": [
        7503
    ],
    "tilung": [
        7504
    ],
    "tiling": [
        7504
    ],
    "tilling": [
        7504
    ],
    "tilung blama": [
        7504
    ],
    "tikar": [
        7505
    ],
    "tikarì": [
        7505
    ],
    "tikali": [
        7505
    ],
    "tikar-east": [
        7505
    ],
    "tikari": [
        7505
    ],
    "tingkala": [
        7505
    ],
    "tillamook": [
        7506
    ],
    "timbe": [
        7507
    ],
    "tindi": [
        7508
    ],
    "tindin": [
        7508
    ],
    "teop": [
        7509
    ],
    "teapu": [
        7509
    ],
    "tiop": [
        7509
    ],
    "trimuris": [
        7510
    ],
    "tiéfo": [
        7511
    ],
    "tyefo": [
        7511
    ],
    "tyeforo": [
        7511
    ],
    "tinigua": [
        7513
    ],
    "tiniguas": [
        7513
    ],
    "tiv": [
        7515
    ],
    "tiwi": [
        7516
    ],
    "tiwa, southern": [
        7517
    ],
    "tigua": [
        7517,
        7823
    ],
    "teduray": [
        7518
    ],
    "tirurai": [
        7518
    ],
    "tiruray": [
        7518
    ],
    "tai hongjin": [
        7519
    ],
    "tajuasohn": [
        7520
    ],
    "tajuason": [
        7520
    ],
    "tajuoso": [
        7520
    ],
    "tajuosohn": [
        7520
    ],
    "tunjung": [
        7521
    ],
    "tunjung dayak": [
        7521
    ],
    "tujia, northern": [
        7522
    ],
    "tuchia": [
        7522,
        7529
    ],
    "tudja": [
        7522
    ],
    "tjungundji": [
        7523
    ],
    "tai laing": [
        7524
    ],
    "tai laeng": [
        7524
    ],
    "tai lai": [
        7524,
        7825,
        7826
    ],
    "tai lang": [
        7524
    ],
    "tai nai": [
        7524
    ],
    "tai naing": [
        7524
    ],
    "timucua": [
        7525
    ],
    "tonjon": [
        7526
    ],
    "tamazight, temacine": [
        7527
    ],
    "temacine": [
        7527
    ],
    "temacine tamazight": [
        7527
    ],
    "touggourt": [
        7527
    ],
    "tougourt": [
        7527
    ],
    "tugurt": [
        7527
    ],
    "tjupany": [
        7528
    ],
    "tujia, southern": [
        7529
    ],
    "tjurruru": [
        7530
    ],
    "thuraru": [
        7530
    ],
    "tjororo": [
        7530
    ],
    "tjuroro": [
        7530
    ],
    "tjururo": [
        7530
    ],
    "tjururu": [
        7530
    ],
    "tchapwurong": [
        7531
    ],
    "thapwurong": [
        7531
    ],
    "tjap": [
        7531
    ],
    "tjap-wurong": [
        7531
    ],
    "tjapwuron": [
        7531
    ],
    "tjapwurong": [
        7531
    ],
    "tjapwurun": [
        7531
    ],
    "tjapwurung": [
        7531
    ],
    "tjapwuurong": [
        7531
    ],
    "tyapawurru": [
        7531
    ],
    "tyapwurru": [
        7531
    ],
    "tyapwuru": [
        7531
    ],
    "türkmen dili": [
        7532,
        7533,
        7534,
        7535
    ],
    "türkmen": [
        7532,
        7533,
        7534,
        7535
    ],
    "torkomani": [
        7532,
        7533,
        7535
    ],
    "trukhmen": [
        7532,
        7533,
        7535
    ],
    "trukhmeny": [
        7532,
        7533,
        7535
    ],
    "turkman": [
        7532,
        7533,
        7535
    ],
    "turkmani": [
        7532,
        7533,
        7535
    ],
    "turkmanian": [
        7532,
        7533,
        7535
    ],
    "turkmencha": [
        7532,
        7533,
        7535
    ],
    "turkmeni": [
        7532,
        7533,
        7535
    ],
    "turkmenian": [
        7532,
        7533,
        7535
    ],
    "turkmenler": [
        7532,
        7533,
        7535
    ],
    "turkomans": [
        7532,
        7533,
        7535
    ],
    "turkpen": [
        7532,
        7533,
        7535
    ],
    "türkmençe": [
        7532,
        7533,
        7535
    ],
    "truká": [
        7536
    ],
    "tukudede": [
        7538
    ],
    "tocod": [
        7538
    ],
    "tokodede": [
        7538
    ],
    "tokodé": [
        7538
    ],
    "tukude": [
        7538
    ],
    "takwane": [
        7539
    ],
    "thakwani": [
        7539
    ],
    "tukumanféd": [
        7540
    ],
    "tekumanfed": [
        7540
    ],
    "tukumaféd": [
        7540
    ],
    "tesaka": [
        7541
    ],
    "tesaka malagasy": [
        7541
    ],
    "tokelauan": [
        7542
    ],
    "takelma": [
        7543
    ],
    "toku-no-shima": [
        7544
    ],
    "tikopia": [
        7545
    ],
    "tee": [
        7546,
        7876
    ],
    "tsakhur": [
        7547,
        7548
    ],
    "tsakhna miz": [
        7547,
        7548
    ],
    "tsakhna": [
        7547,
        7548
    ],
    "tsakhury": [
        7547,
        7548
    ],
    "tsaxur": [
        7547,
        7548
    ],
    "ts‘əxna miz": [
        7547,
        7548
    ],
    "ts‘əxna": [
        7547,
        7548
    ],
    "ts’axna miz": [
        7547,
        7548
    ],
    "ts’axna": [
        7547,
        7548
    ],
    "ts’axurskii yazyk": [
        7547,
        7548
    ],
    "ts’axurskii": [
        7547,
        7548
    ],
    "takestani": [
        7549
    ],
    "takistani": [
        7549
    ],
    "tharu, kathariya": [
        7550
    ],
    "totonac, upper necaxa": [
        7551
    ],
    "totonaco del río necaxa": [
        7551
    ],
    "totonaco": [
        7691,
        7551,
        7576,
        7640,
        7649,
        7650,
        7653
    ],
    "teanu": [
        7553
    ],
    "tangko": [
        7554
    ],
    "takua": [
        7555
    ],
    "tepehuan, southwestern": [
        7560
    ],
    "tepehuán del suroeste": [
        7560
    ],
    "tobelo": [
        7561
    ],
    "totonac, yecuatla": [
        7562
    ],
    "talaud": [
        7563
    ],
    "talaur": [
        7563
    ],
    "talaut": [
        7563
    ],
    "talodda": [
        7563
    ],
    "telefol": [
        7564
    ],
    "teleefool": [
        7564
    ],
    "telefolmin": [
        7564
    ],
    "telefomin": [
        7564
    ],
    "tofanma": [
        7565
    ],
    "tofamna": [
        7565
    ],
    "tlhingan hol": [
        7566,
        7567
    ],
    "tlhingan": [
        7566,
        7567
    ],
    "tlingit": [
        7568,
        7569
    ],
    "thlinget": [
        7568,
        7569
    ],
    "tlinkit": [
        7568,
        7569
    ],
    "talinga-bwisi": [
        7570
    ],
    "talinga": [
        7570
    ],
    "talinge": [
        7570
    ],
    "taloki": [
        7571
    ],
    "taaloki": [
        7571
    ],
    "talloki": [
        7571
    ],
    "taluki": [
        7571
    ],
    "tetela": [
        7572
    ],
    "tolomako": [
        7573
    ],
    "tolomako-jereviu": [
        7573
    ],
    "talondo’": [
        7574
    ],
    "talondo kondo": [
        7574
    ],
    "talondo": [
        7574
    ],
    "talondo'": [
        7574
    ],
    "talodi": [
        7575
    ],
    "totonac, filomena mata-coahuitlán": [
        7576
    ],
    "totonaco central del norte": [
        7576
    ],
    "totonaco de filomena mata-coahuitlán": [
        7576
    ],
    "tai loi": [
        7577
    ],
    "tai doi": [
        7577
    ],
    "tai-loi": [
        7577
    ],
    "tailoi": [
        7577
    ],
    "talise": [
        7578
    ],
    "talisi": [
        7578
    ],
    "tolo": [
        7578
    ],
    "tambotalo": [
        7579
    ],
    "taluti": [
        7580
    ],
    "tehoru": [
        7580
    ],
    "teluti": [
        7580
    ],
    "tihoru": [
        7580
    ],
    "tulehu": [
        7581
    ],
    "teru": [
        7581,
        8997
    ],
    "taliabu": [
        7582
    ],
    "taliabo": [
        7582
    ],
    "talysh": [
        7584,
        7585,
        7586
    ],
    "talesh": [
        7584,
        7585,
        7586
    ],
    "taleshi": [
        7584,
        7585,
        7586
    ],
    "talish": [
        7584,
        7585,
        7586
    ],
    "talishi": [
        7584,
        7585,
        7586
    ],
    "talyshi": [
        7584,
        7585,
        7586
    ],
    "tolish": [
        7584,
        7585,
        7586
    ],
    "tolışə zıvon": [
        7584,
        7585,
        7586
    ],
    "tolışə": [
        7584,
        7585,
        7586
    ],
    "tama (chad)": [
        7587
    ],
    "tamok": [
        7587
    ],
    "tamongobo": [
        7587
    ],
    "tamot": [
        7587
    ],
    "taremp": [
        7588
    ],
    "tembimbe-katbol": [
        7588
    ],
    "tisvel": [
        7588
    ],
    "tumak": [
        7589
    ],
    "təmàgə́ə̀n": [
        7589
    ],
    "toumak": [
        7589
    ],
    "tumac": [
        7589
    ],
    "tumag": [
        7589
    ],
    "tummok": [
        7589
    ],
    "tremembé": [
        7591
    ],
    "taramembé": [
        7591
    ],
    "teremembé": [
        7591
    ],
    "toba-maskoy": [
        7592
    ],
    "toba of paraguay": [
        7592
    ],
    "toba-enenlhet": [
        7592
    ],
    "ternateño": [
        7593
    ],
    "ternatenyo": [
        7593
    ],
    "tamajaq, tawallammat": [
        7595,
        7596,
        7594
    ],
    "tamajaq": [
        7595,
        7596,
        7594
    ],
    "tawallammat": [
        7595,
        7596,
        7594
    ],
    "tahoua": [
        7594,
        7595,
        7596
    ],
    "tahoua tamajeq": [
        7594,
        7595,
        7596
    ],
    "tajag": [
        7594,
        7595,
        7596
    ],
    "tewellemet": [
        7594,
        7595,
        7596
    ],
    "tutuba": [
        7597
    ],
    "tamaja": [
        7598
    ],
    "tamaya": [
        7598
    ],
    "tamang, northwestern": [
        7599
    ],
    "tamang gyoi": [
        7599
    ],
    "tamang lengmo": [
        7599
    ],
    "tamnim": [
        7600
    ],
    "tamnim citak": [
        7600
    ],
    "tai thanh": [
        7601
    ],
    "tai man thanh": [
        7601
    ],
    "táy thanh": [
        7601
    ],
    "táy": [
        7601,
        7825,
        7826
    ],
    "taman (indonesia)": [
        7602
    ],
    "taman dayak": [
        7602
    ],
    "temoq": [
        7603
    ],
    "tumleo": [
        7604
    ],
    "talmudic": [
        7605
    ],
    "tima": [
        7606
    ],
    "tamanik": [
        7606
    ],
    "tasmate": [
        7607
    ],
    "tembo (motembo)": [
        7609
    ],
    "temuan": [
        7610
    ],
    "tami": [
        7611
    ],
    "tamanaku": [
        7612
    ],
    "tamanaco": [
        7612
    ],
    "tamañkú": [
        7612
    ],
    "tshwana": [
        7613
    ],
    "tsiwaha": [
        7613
    ],
    "tswana": [
        7614,
        7613
    ],
    "tacana": [
        7615
    ],
    "takana": [
        7615
    ],
    "tupamasa": [
        7615
    ],
    "tunebo, western": [
        7616
    ],
    "tanimuca-retuarã": [
        7617
    ],
    "tanimboka": [
        7617
    ],
    "tanimuca-letuama": [
        7617
    ],
    "tunebo, angosturas": [
        7618
    ],
    "tobanga": [
        7619
    ],
    "tandia": [
        7621
    ],
    "taha": [
        7623
    ],
    "tabla": [
        7624
    ],
    "tanah merah": [
        7624
    ],
    "tepera": [
        7624
    ],
    "tanna, north": [
        7625
    ],
    "tana": [
        7625
    ],
    "toromono": [
        7626
    ],
    "toromona": [
        7626
    ],
    "taíno": [
        7628
    ],
    "taino": [
        7628
    ],
    "tandanke": [
        7629
    ],
    "tendanke": [
        7629
    ],
    "tenis": [
        7630
    ],
    "tench": [
        7630
    ],
    "tontemboan": [
        7631
    ],
    "tompakewa": [
        7631
    ],
    "tountemboan": [
        7631
    ],
    "tai kang": [
        7632
    ],
    "tay chieng": [
        7632
    ],
    "tay khang": [
        7632
    ],
    "tangchangya": [
        7633
    ],
    "tanchangya": [
        7633
    ],
    "tonsawang": [
        7634
    ],
    "tombatu": [
        7634
    ],
    "toundanow": [
        7634
    ],
    "tanema": [
        7635
    ],
    "tetau": [
        7635
    ],
    "tetawo": [
        7635
    ],
    "tongwe": [
        7636
    ],
    "ten’edn": [
        7637
    ],
    "tean-ean": [
        7637
    ],
    "ten'edn": [
        7637
    ],
    "ten’en": [
        7637
    ],
    "tonga-mos": [
        7637
    ],
    "tongan": [
        7638
    ],
    "tonga (tonga islands)": [
        7638
    ],
    "takshika": [
        7639
    ],
    "toba qom": [
        7639
    ],
    "toba sur": [
        7639
    ],
    "totonac, coyutla": [
        7640
    ],
    "tutunakú": [
        7640,
        7650,
        7653
    ],
    "totonaco de coyutla": [
        7640
    ],
    "toma": [
        7641
    ],
    "toale": [
        7641
    ],
    "toali": [
        7641
    ],
    "tooma": [
        7641
    ],
    "toga": [
        7642
    ],
    "tonga (nyasa)": [
        7643
    ],
    "tonga-inhambane": [
        7644
    ],
    "tonga (zambia)": [
        7645
    ],
    "tojolabal": [
        7646
    ],
    "tojol-ab’al": [
        7646
    ],
    "tolowa": [
        7647
    ],
    "tombulu": [
        7648
    ],
    "tombalu": [
        7648
    ],
    "tombula": [
        7648
    ],
    "tombulu’": [
        7648
    ],
    "toumbulu": [
        7648
    ],
    "totonac, xicotepec de juárez": [
        7649
    ],
    "totonaco de villa juárez": [
        7649
    ],
    "totonaco del norte": [
        7649
    ],
    "totonako": [
        7649
    ],
    "totonac, papantla": [
        7650
    ],
    "totonaco de papantla": [
        7650
    ],
    "toposa": [
        7651
    ],
    "taposa": [
        7651
    ],
    "topotha": [
        7651
    ],
    "togbo-vara": [
        7652
    ],
    "togbo-vara banda": [
        7652
    ],
    "totonac, highland": [
        7653
    ],
    "totonaco de la sierra": [
        7653
    ],
    "taromi, upper": [
        7655
    ],
    "taromi": [
        7655
    ],
    "towa": [
        7656
    ],
    "tobian": [
        7657
    ],
    "tobi": [
        7657
    ],
    "topoiyo": [
        7658
    ],
    "taupota": [
        7660
    ],
    "tsìndíì": [
        7661
    ],
    "tlapaneco de azoyú": [
        7661
    ],
    "tlapaneco del sur": [
        7661
    ],
    "tippera": [
        7662,
        7663,
        7714,
        7715
    ],
    "tipperah": [
        7662,
        7663
    ],
    "tippurah": [
        7662,
        7663
    ],
    "triperah": [
        7662,
        7663
    ],
    "tripura": [
        7662,
        7663,
        7714,
        7715
    ],
    "tarpia": [
        7664
    ],
    "tarfia": [
        7664
    ],
    "tok pisin": [
        7666
    ],
    "tapiete": [
        7667
    ],
    "tapieté": [
        7667
    ],
    "tirumbae": [
        7667
    ],
    "tupinikin": [
        7668
    ],
    "tupinaki": [
        7668
    ],
    "tupinikim": [
        7668
    ],
    "tupiniquim": [
        7668
    ],
    "tupiniquin": [
        7668
    ],
    "tupiniquín": [
        7668
    ],
    "tlacoapa": [
        7669
    ],
    "tlacoapa me'phaa": [
        7669
    ],
    "tlacoapa tlapanec": [
        7669
    ],
    "tlapaneco de tlacoapa": [
        7669
    ],
    "tlapaneco del centro": [
        7669
    ],
    "tampulma": [
        7670
    ],
    "tampele": [
        7670
    ],
    "tamplima": [
        7670
    ],
    "tampole": [
        7670
    ],
    "tampolem": [
        7670
    ],
    "tampolense": [
        7670
    ],
    "tamprusi": [
        7670
    ],
    "tupinambá": [
        7671
    ],
    "tai pao": [
        7672
    ],
    "tai hang tong": [
        7672
    ],
    "tai paw": [
        7672
    ],
    "thai muong": [
        7672,
        7865,
        7866
    ],
    "tày muòng": [
        7672
    ],
    "tepehua, pisaflores": [
        7673
    ],
    "tukpa": [
        7674
    ],
    "tuparí": [
        7675
    ],
    "tepehua, tlachichilco": [
        7676
    ],
    "tlachichilco": [
        7676
    ],
    "tlachichilco tepehua": [
        7676
    ],
    "tampuan": [
        7677
    ],
    "tamphuan": [
        7677
    ],
    "tampuen": [
        7677
    ],
    "tampuon": [
        7677
    ],
    "tanapag": [
        7678
    ],
    "talaabog": [
        7678
    ],
    "talaabwogh": [
        7678
    ],
    "tlapaneco de acatepec": [
        7680
    ],
    "tlapaneco del suroeste": [
        7680
    ],
    "trumai": [
        7681
    ],
    "tinputz": [
        7682
    ],
    "timputs": [
        7682
    ],
    "tembé": [
        7683
    ],
    "tenetehara": [
        7683
    ],
    "timbé": [
        7683
    ],
    "turiwara": [
        7683,
        7834
    ],
    "teqel": [
        7684
    ],
    "turumsa": [
        7685
    ],
    "tenino": [
        7686
    ],
    "toaripi": [
        7687
    ],
    "tomoip": [
        7688
    ],
    "tomoive": [
        7688
    ],
    "tomoyp": [
        7688
    ],
    "tumie": [
        7688
    ],
    "tumuip": [
        7688
    ],
    "tunni": [
        7689
    ],
    "torona": [
        7690
    ],
    "totonaco del cerro xinolatépetl": [
        7691
    ],
    "totonaco norte de huauchinango": [
        7691
    ],
    "totonaco de ozomatlán": [
        7691
    ],
    "touo": [
        7692
    ],
    "tonkawa": [
        7693
    ],
    "türkçe": [
        7694,
        7697,
        7695,
        7696,
        7698,
        7699
    ],
    "türkisch": [
        7694,
        7695,
        7696,
        7699
    ],
    "tirahi": [
        7700
    ],
    "terebu": [
        7701
    ],
    "terepu": [
        7701
    ],
    "turubu": [
        7701
    ],
    "turupu": [
        7701
    ],
    "triqui, copala": [
        7702
    ],
    "triqui": [
        7702,
        7716,
        7718
    ],
    "trique": [
        7702,
        7716,
        7718
    ],
    "trike": [
        7702,
        7718
    ],
    "triqui bajo": [
        7702
    ],
    "triqui de san juan copala": [
        7702
    ],
    "turi": [
        7703
    ],
    "tarangan, east": [
        7704
    ],
    "tarangan": [
        7704,
        7849
    ],
    "trangan": [
        7704,
        7849
    ],
    "tarangan timur": [
        7704
    ],
    "trinidadian english creole": [
        7705
    ],
    "trinidadian creole english": [
        7705
    ],
    "turaka": [
        7707
    ],
    "trió": [
        7708
    ],
    "tarona": [
        7708
    ],
    "tarëno": [
        7708
    ],
    "tarëno ijomi": [
        7708
    ],
    "tiriyó": [
        7708
    ],
    "tirió": [
        7708
    ],
    "toram": [
        7709
    ],
    "torom": [
        7709
    ],
    "torum": [
        7709
    ],
    "traveller scottish": [
        7710
    ],
    "tregami": [
        7711
    ],
    "trigami": [
        7711
    ],
    "trinitario": [
        7712
    ],
    "tarao": [
        7713
    ],
    "tarao naga": [
        7713
    ],
    "taraotrong": [
        7713
    ],
    "tarau": [
        7713
    ],
    "tripuri": [
        8661,
        7714,
        7715
    ],
    "triqui, san martín itunyoso": [
        7716
    ],
    "triqui alto": [
        7716,
        7718
    ],
    "triqui de san martín itunyoso": [
        7716
    ],
    "taushiro": [
        7717
    ],
    "triqui, chicahuaxtla": [
        7718
    ],
    "triqui de san andrés chicahuaxtla": [
        7718
    ],
    "tunggare": [
        7719
    ],
    "tarunggare": [
        7719
    ],
    "turunggare": [
        7719
    ],
    "turoyo": [
        7720,
        7721
    ],
    "turani": [
        7720,
        7721
    ],
    "taroko": [
        7722
    ],
    "taruku": [
        7722
    ],
    "toroko": [
        7722
    ],
    "torwali": [
        7723
    ],
    "torwalak": [
        7723
    ],
    "torwalik": [
        7723
    ],
    "turvali": [
        7723
    ],
    "tringgus-sembaan": [
        7724
    ],
    "tringgus-sembaan bidayuh": [
        7724
    ],
    "tringus": [
        7724
    ],
    "turung": [
        7725
    ],
    "tai turung": [
        7725
    ],
    "tailung": [
        7725
    ],
    "tairong": [
        7725
    ],
    "torá": [
        7726
    ],
    "tora": [
        7726
    ],
    "toraz": [
        7726
    ],
    "torerizes": [
        7726
    ],
    "toré": [
        7726
    ],
    "turá": [
        7726
    ],
    "tsonga": [
        7727,
        7728
    ],
    "thonga": [
        7727,
        7728
    ],
    "tsaangi": [
        7729
    ],
    "tcengui": [
        7729
    ],
    "tchangui": [
        7729
    ],
    "tsangi": [
        7729
    ],
    "tsengi": [
        7729
    ],
    "tsamai": [
        7730
    ],
    "tswa": [
        7731
    ],
    "tsakonian": [
        7732
    ],
    "tsakonia": [
        7732
    ],
    "tunisian sign language": [
        7733
    ],
    "tausug": [
        7734,
        7735
    ],
    "taosug": [
        7734,
        7735
    ],
    "tausog": [
        7734,
        7735
    ],
    "taw sug": [
        7734,
        7735
    ],
    "taw": [
        7734,
        7735
    ],
    "tsuvan": [
        7736
    ],
    "tchede": [
        7736
    ],
    "telaki": [
        7736
    ],
    "teleki": [
        7736
    ],
    "terki": [
        7736
    ],
    "tsimshian": [
        7737
    ],
    "tsimshianic": [
        7737
    ],
    "tsimpshean": [
        7737
    ],
    "tsimshean": [
        7737
    ],
    "tshangla": [
        7738
    ],
    "tsangla monba": [
        7738
    ],
    "tschanglo": [
        7738
    ],
    "tseku": [
        7739
    ],
    "tsuku": [
        7739
    ],
    "tzuku": [
        7739
    ],
    "ts’ün-lao": [
        7740
    ],
    "ts'ün-lao": [
        7740
    ],
    "turkish sign language": [
        7741
    ],
    "türk i̇şaret dili": [
        7741
    ],
    "türk": [
        7741
    ],
    "ti̇d": [
        7741
    ],
    "toussian, northern": [
        7742
    ],
    "toussian": [
        7742,
        8228
    ],
    "tusia": [
        7742,
        8228
    ],
    "tusian": [
        7742,
        8228
    ],
    "tusya": [
        7742,
        8228
    ],
    "tusyang": [
        7742,
        8228
    ],
    "thai sign language": [
        7743
    ],
    "thsl": [
        7743
    ],
    "tasiriki": [
        7744
    ],
    "taiwan sign language": [
        7745
    ],
    "taiwan": [
        7745
    ],
    "taiwan shouyu": [
        7745
    ],
    "taiwan ziran shouyu": [
        7745
    ],
    "tondi songway kiini": [
        7746
    ],
    "tondi": [
        7746
    ],
    "tsk": [
        7746
    ],
    "tsou": [
        7747
    ],
    "tibola": [
        7747
    ],
    "tibolah": [
        7747
    ],
    "tibolak": [
        7747
    ],
    "tibolal": [
        7747
    ],
    "tsoo": [
        7747
    ],
    "tsu-u": [
        7747
    ],
    "tsu-wo": [
        7747
    ],
    "tsuou": [
        7747
    ],
    "tzo": [
        7747
    ],
    "tsogo": [
        7748
    ],
    "tao-suamato": [
        7750
    ],
    "tao-suame": [
        7750
    ],
    "tebul sign language": [
        7751
    ],
    "tartar": [
        7753,
        7754
    ],
    "tata’er": [
        7753,
        7754
    ],
    "tutelo": [
        7755
    ],
    "tiba": [
        7756
    ],
    "tәbaya": [
        7756
    ],
    "tektiteko": [
        7757
    ],
    "tectitec": [
        7757
    ],
    "tectiteco": [
        7757
    ],
    "tectitán mam": [
        7757
    ],
    "tectitán": [
        7757
    ],
    "tectitán mame": [
        7757
    ],
    "tujqyol": [
        7757
    ],
    "tauade": [
        7758
    ],
    "tauata": [
        7758
    ],
    "tubetube": [
        7759
    ],
    "tuotomb": [
        7760
    ],
    "tuotom": [
        7760
    ],
    "tuotomp": [
        7760
    ],
    "tutung": [
        7761
    ],
    "ta’oih, upper": [
        7762
    ],
    "ta’oih": [
        7762,
        7769
    ],
    "t-oy": [
        7762
    ],
    "ta hoi": [
        7762
    ],
    "ta-oi": [
        7762
    ],
    "ta-oy": [
        7762
    ],
    "ta-oiq": [
        7762
    ],
    "tau oi": [
        7762
    ],
    "ta’oiq": [
        7762
    ],
    "toi-oi": [
        7762
    ],
    "tà-oi": [
        7762
    ],
    "taoih": [
        7762,
        7769
    ],
    "tobati": [
        7763
    ],
    "tobwadic": [
        7763
    ],
    "tooro": [
        7764
    ],
    "totoro": [
        7765
    ],
    "totela": [
        7766
    ],
    "tutchone, northern": [
        7767
    ],
    "tutchone du nord": [
        7767
    ],
    "towei": [
        7768
    ],
    "towe": [
        7768
    ],
    "ta’oih, lower": [
        7769
    ],
    "tombelala": [
        7770
    ],
    "thai, northeastern": [
        7772
    ],
    "thai isaan": [
        7772
    ],
    "tat, muslim": [
        7773,
        7774,
        7775
    ],
    "tats": [
        7773,
        7775
    ],
    "torau": [
        7776
    ],
    "titan": [
        7777
    ],
    "tito": [
        7777
    ],
    "tutoh kenya": [
        7778
    ],
    "tutoh": [
        7778
    ],
    "tutoh kenyah": [
        7778
    ],
    "tori": [
        7779
    ],
    "tori aikwakai": [
        7779
    ],
    "tsum": [
        7780
    ],
    "tsumba": [
        7780
    ],
    "tsumge": [
        7780
    ],
    "tübatulabal": [
        7782
    ],
    "tuam": [
        7783,
        7784,
        7785
    ],
    "tuam-mutu": [
        7783,
        7784,
        7785
    ],
    "tuom": [
        7783,
        7784,
        7785
    ],
    "tuxá": [
        7786
    ],
    "todela": [
        7786
    ],
    "tusha": [
        7786
    ],
    "tushá": [
        7786
    ],
    "tuyuca": [
        7787
    ],
    "tejuca": [
        7787
    ],
    "tuiuca": [
        7787
    ],
    "tuyuka": [
        7787
    ],
    "tunebo, central": [
        7788
    ],
    "tunia": [
        7789
    ],
    "tounia": [
        7789
    ],
    "tun": [
        7789
    ],
    "tunya": [
        7789
    ],
    "tulil": [
        7790
    ],
    "taulil": [
        7790
    ],
    "tupuri": [
        7791
    ],
    "tongoyna": [
        7791
    ],
    "toubouri": [
        7791
    ],
    "toupouri": [
        7791
    ],
    "tpuri": [
        7791
    ],
    "tuburi": [
        7791
    ],
    "tpür": [
        7791
    ],
    "tüpür": [
        7791
    ],
    "tüpürï": [
        7791
    ],
    "tugutil": [
        7792
    ],
    "tula": [
        7793,
        8819
    ],
    "tumbuka": [
        7794
    ],
    "tamboka": [
        7794
    ],
    "tambuka": [
        7794
    ],
    "tew": [
        7794
    ],
    "timbuka": [
        7794
    ],
    "tombucas": [
        7794
    ],
    "tumboka": [
        7794
    ],
    "tunica": [
        7795
    ],
    "tonica": [
        7795
    ],
    "tucano": [
        7796
    ],
    "takuna": [
        7796
    ],
    "tukana": [
        7796
    ],
    "tukano": [
        7796
    ],
    "tukána": [
        7796
    ],
    "tedaga": [
        7797
    ],
    "tudaga": [
        7797
    ],
    "tebou": [
        7797
    ],
    "teda": [
        7797
    ],
    "tibbu": [
        7797
    ],
    "todaga": [
        7797
    ],
    "todga": [
        7797
    ],
    "tuscarora": [
        7798
    ],
    "tututni": [
        7799
    ],
    "turkana": [
        7800
    ],
    "turkwana": [
        7800
    ],
    "tuxináwa": [
        7801
    ],
    "tuchinaua": [
        7801
    ],
    "tushinawa": [
        7801
    ],
    "tutxinawa": [
        7801
    ],
    "tuxinaua": [
        7801
    ],
    "tuxinawa": [
        7801
    ],
    "tugen": [
        7802
    ],
    "tukēn": [
        7802
    ],
    "turka": [
        7803
    ],
    "tchourama": [
        7803
    ],
    "tourka": [
        7803
    ],
    "turuka": [
        7803
    ],
    "tyurama": [
        7803
    ],
    "tavola": [
        7804
    ],
    "tavula": [
        7804
    ],
    "tsuvadi": [
        7805
    ],
    "te’un": [
        7806
    ],
    "te'un": [
        7806
    ],
    "tuvaluan": [
        7808
    ],
    "te ’gana tūvalu": [
        7808
    ],
    "tūvalu": [
        7808
    ],
    "tela-masbuar": [
        7809
    ],
    "tela’a": [
        7809
    ],
    "tavoyan": [
        7810
    ],
    "tavoya": [
        7810
    ],
    "tawe-tavoy": [
        7810
    ],
    "tidore": [
        7811
    ],
    "taveta": [
        7812
    ],
    "tubeta": [
        7812
    ],
    "tutsa": [
        7813
    ],
    "totcha": [
        7813
    ],
    "tutsa naga": [
        7813
    ],
    "tunen": [
        7814
    ],
    "tawaelia": [
        7815
    ],
    "tawailia": [
        7815
    ],
    "tawelia": [
        7815
    ],
    "topobaria": [
        7815
    ],
    "taivoan": [
        7816
    ],
    "taivuan": [
        7816
    ],
    "tevorang": [
        7816
    ],
    "tevorangh": [
        7816
    ],
    "timor creole portuguese": [
        7817
    ],
    "timor pidgin": [
        7817
    ],
    "twana": [
        7818
    ],
    "ti’tuwaduqut’sid": [
        7818
    ],
    "tuwa’duqx": [
        7818
    ],
    "teshenawa": [
        7820
    ],
    "twents": [
        7821
    ],
    "twente": [
        7821
    ],
    "teiwa": [
        7822
    ],
    "tewa (indonesia)": [
        7822
    ],
    "tiwa, northern": [
        7823
    ],
    "tereweng": [
        7824
    ],
    "tai dón": [
        7825,
        7826
    ],
    "tai blanc": [
        7825,
        7826
    ],
    "tai jinping": [
        7825,
        7826
    ],
    "tai kao": [
        7825,
        7826
    ],
    "thái tráng": [
        7825,
        7826
    ],
    "táy khao": [
        7825,
        7826
    ],
    "tawang": [
        7828
    ],
    "takpa": [
        7828
    ],
    "tawan monba": [
        7828
    ],
    "tawan": [
        7828
    ],
    "tawang monpa": [
        7828
    ],
    "twendi": [
        7829
    ],
    "tswapong": [
        7830
    ],
    "tasawaq": [
        7832
    ],
    "tasawaq senni": [
        7832
    ],
    "tarahumara, southwestern": [
        7833
    ],
    "tarahumara del suroeste": [
        7833
    ],
    "turiwára": [
        7834
    ],
    "turiguara": [
        7834
    ],
    "turiuara": [
        7834
    ],
    "termanu": [
        7835
    ],
    "tuwari": [
        7836
    ],
    "tewe": [
        7837
    ],
    "teve": [
        7837
    ],
    "tawoyan": [
        7838
    ],
    "tabojan": [
        7838
    ],
    "tabojan tongka": [
        7838
    ],
    "tongka": [
        7838
    ],
    "taboyan": [
        7838
    ],
    "tabuyan": [
        7838
    ],
    "tawoyan dayak": [
        7838
    ],
    "tewoyan": [
        7838
    ],
    "tombonuo": [
        7839
    ],
    "tambanua": [
        7839
    ],
    "tambanuo": [
        7839
    ],
    "tambanuva": [
        7839
    ],
    "tambanwas": [
        7839
    ],
    "tambenua": [
        7839
    ],
    "tambunwas": [
        7839
    ],
    "tangar nu tombonuo": [
        7839
    ],
    "tangar": [
        7839
    ],
    "tembenua": [
        7839
    ],
    "tombonuva": [
        7839
    ],
    "tombonuwo": [
        7839
    ],
    "tumbunwha": [
        7839
    ],
    "tunbumohas": [
        7839
    ],
    "tokharian b": [
        7840,
        7841
    ],
    "tokharian": [
        7840,
        7841,
        8657
    ],
    "tsetsaut": [
        7842
    ],
    "totoli": [
        7843
    ],
    "tolitoli": [
        7843
    ],
    "tontoli": [
        7843
    ],
    "tangut": [
        7844
    ],
    "thracian": [
        7845
    ],
    "tonore": [
        7846
    ],
    "tunuli": [
        7846
    ],
    "txicão": [
        7846
    ],
    "txikân": [
        7846
    ],
    "txikão": [
        7846
    ],
    "tarjumo": [
        7847
    ],
    "tomini": [
        7848
    ],
    "tiadje": [
        7848
    ],
    "tialo": [
        7848
    ],
    "tarangan, west": [
        7849
    ],
    "tarangan barat": [
        7849
    ],
    "toto": [
        7850,
        7851,
        7852
    ],
    "tii": [
        7853
    ],
    "thie": [
        7853
    ],
    "tartessian": [
        7854
    ],
    "tonsea": [
        7855
    ],
    "tonsea’": [
        7855
    ],
    "tjitak": [
        7856
    ],
    "tjitjak": [
        7856
    ],
    "tatana": [
        7858
    ],
    "tatanaq": [
        7858
    ],
    "tatana’": [
        7858
    ],
    "tanosy": [
        7859
    ],
    "tanosy malagasy": [
        7859
    ],
    "tahitian": [
        7860
    ],
    "tahiti": [
        7860
    ],
    "tauya": [
        7861
    ],
    "tienga": [
        7862
    ],
    "tyanga": [
        7862
    ],
    "tyenga": [
        7862
    ],
    "teke-tsaayi": [
        7864
    ],
    "tsaayi": [
        7864
    ],
    "tsaya": [
        7864
    ],
    "tsaye": [
        7864
    ],
    "tsayi": [
        7864
    ],
    "tai yo": [
        7865,
        7866
    ],
    "tai maen": [
        7865,
        7866
    ],
    "tai man": [
        7865,
        7866
    ],
    "tai men": [
        7865,
        7866
    ],
    "tai mene": [
        7865,
        7866
    ],
    "tai mène": [
        7865,
        7866
    ],
    "tai mènè": [
        7865,
        7866
    ],
    "tai-maen": [
        7865,
        7866
    ],
    "tay muoi": [
        7865,
        7866
    ],
    "tay quy chau": [
        7865,
        7866
    ],
    "tay yo": [
        7865,
        7866
    ],
    "tay-jo": [
        7865,
        7866
    ],
    "thu lao": [
        7867,
        7878,
        9044,
        9045
    ],
    "thu": [
        7867,
        7878,
        9044,
        9045
    ],
    "thaypan": [
        7869
    ],
    "tai daeng": [
        7870
    ],
    "tai deng": [
        7870
    ],
    "tai muoi": [
        7870
    ],
    "tai nhai": [
        7870
    ],
    "tai rouge": [
        7870
    ],
    "thai dang": [
        7870
    ],
    "thai do": [
        7870
    ],
    "táy-môc-châu": [
        7870
    ],
    "tày sa pa": [
        7871
    ],
    "tai sa pa": [
        7871
    ],
    "tày tac": [
        7872,
        7873
    ],
    "tac": [
        7872,
        7873
    ],
    "tyhua": [
        7874
    ],
    "tyua": [
        7874
    ],
    "tuvan": [
        7875
    ],
    "tannu-tuva": [
        7875
    ],
    "tokha": [
        7875
    ],
    "tuva": [
        7875
    ],
    "tuva-uriankhai": [
        7875
    ],
    "tuvia": [
        7875
    ],
    "tuvin": [
        7875
    ],
    "tuvinian": [
        7875
    ],
    "tuwa": [
        7875
    ],
    "tuwa-uriankhai": [
        7875
    ],
    "tyvan": [
        7875
    ],
    "teke-tyee": [
        7876
    ],
    "tyee": [
        7876
    ],
    "tiyaa": [
        7877
    ],
    "tiya": [
        7877
    ],
    "tai tho": [
        7878
    ],
    "t’o": [
        7878
    ],
    "tanzanian sign language": [
        7879
    ],
    "tanzanian": [
        7879,
        8561
    ],
    "tzeltal": [
        7880
    ],
    "tenejapa": [
        7880
    ],
    "tenejapa tzeltal": [
        7880
    ],
    "tseltal": [
        7880
    ],
    "tz’utujil": [
        7881,
        7882
    ],
    "tz'utujil": [
        7881
    ],
    "tzutujil": [
        7881,
        7882
    ],
    "tzutuhil": [
        7881,
        7882
    ],
    "tzutujil oriental": [
        7881,
        7882
    ],
    "tz'utujil - western": [
        7882
    ],
    "talossan": [
        7883
    ],
    "tamazight, central atlas": [
        7884,
        7885,
        7886
    ],
    "tamaziɣt n laṭlaṣ": [
        7884
    ],
    "tamaziɣt": [
        7884
    ],
    "tugun": [
        7887
    ],
    "tzotzil": [
        7888,
        7889,
        7890,
        7891
    ],
    "tsotsil": [
        7888,
        7889,
        7890,
        7891
    ],
    "tzotzil - huixtan": [
        7889
    ],
    "tzotzil - san andres": [
        7890
    ],
    "tzotzil - zinacantan": [
        7891
    ],
    "tabriak": [
        7892
    ],
    "tai guan": [
        7894
    ],
    "tai khouan": [
        7894
    ],
    "tai kouane": [
        7894
    ],
    "tai kuan": [
        7894
    ],
    "tai kwan": [
        7894
    ],
    "tairuma": [
        7895
    ],
    "tairuma’a": [
        7895
    ],
    "tazy": [
        7906
    ],
    "twampa": [
        7913
    ],
    "tanjijili": [
        7930
    ],
    "tufungwa": [
        7944
    ],
    "tonocoté": [
        7947
    ],
    "tubbi": [
        7952
    ],
    "tirax": [
        7986
    ],
    "tayon": [
        7999
    ],
    "talay": [
        8000
    ],
    "tubiruasa": [
        8003
    ],
    "turumawa": [
        8026
    ],
    "tshivenḓa": [
        8067,
        8068
    ],
    "talian": [
        8069
    ],
    "taliano": [
        8069
    ],
    "tiếng việt": [
        8078
    ],
    "tiếng": [
        8078
    ],
    "tiếng việt": [
        8078,
        8079,
        8080
    ],
    "tiếng": [
        8078,
        8079,
        8080
    ],
    "tshivili": [
        8083
    ],
    "tsivili": [
        8083
    ],
    "tenggarong": [
        8099
    ],
    "tenggarong kutai malay": [
        8099
    ],
    "tavue": [
        8110
    ],
    "temascal": [
        8117
    ],
    "tamazola": [
        8125
    ],
    "tamazola mixtec": [
        8125
    ],
    "teget": [
        8129
    ],
    "telag": [
        8129
    ],
    "tšeeli": [
        8133,
        8134
    ],
    "takar": [
        8142
    ],
    "tunayana-waiwai": [
        8171
    ],
    "tidni": [
        8222
    ],
    "tidnie": [
        8222
    ],
    "titnie": [
        8222
    ],
    "toussian, southern": [
        8228
    ],
    "tupi do rio machado": [
        8240
    ],
    "tok vitu": [
        8242
    ],
    "tsaurasya": [
        8275
    ],
    "tarino": [
        8290
    ],
    "tjerait": [
        8304
    ],
    "tyaraity": [
        8304
    ],
    "tyeraity": [
        8304
    ],
    "tukkongo": [
        8316
    ],
    "tukongo": [
        8316
    ],
    "tukungo": [
        8316
    ],
    "telugu gondi": [
        8343,
        8344,
        8345,
        8346
    ],
    "tapacua": [
        8409
    ],
    "thoorgine": [
        8426
    ],
    "tourou": [
        8451
    ],
    "tur": [
        8451
    ],
    "turu-hide": [
        8451
    ],
    "tloue": [
        8452
    ],
    "tloutle": [
        8452
    ],
    "tornasi": [
        8453
    ],
    "tarumbal": [
        8468
    ],
    "tharumbal": [
        8468
    ],
    "tankarana": [
        8551
    ],
    "tankarana malagasy": [
        8551
    ],
    "tsimihety": [
        8552
    ],
    "tsimihety malagasy": [
        8552
    ],
    "tanzanian ngoni": [
        8561
    ],
    "tarof": [
        8576
    ],
    "tta komo": [
        8580
    ],
    "tta": [
        8580
    ],
    "tasmanian": [
        8668,
        8589,
        8591,
        8592,
        8594,
        8598,
        8608,
        8609,
        8610,
        8612
    ],
    "tyerrenoterpanner": [
        8594
    ],
    "tommeginne": [
        8608
    ],
    "toogee": [
        8610
    ],
    "tage": [
        8618
    ],
    "taze": [
        8618
    ],
    "tamnye": [
        8639,
        8640
    ],
    "tsanuma": [
        8642
    ],
    "tsanɨma": [
        8642
    ],
    "tnuꞌun dau": [
        8648
    ],
    "tnuꞌun": [
        8648
    ],
    "tnu’un dau": [
        8648
    ],
    "transalpine gaulish": [
        8650
    ],
    "transalpine": [
        8650
    ],
    "tjuop": [
        8651
    ],
    "teita mixtec": [
        8653
    ],
    "tijaltepec": [
        8654
    ],
    "tijaltepec mixtec": [
        8654
    ],
    "tokharian a": [
        8657
    ],
    "tumshuqese": [
        8659,
        8660
    ],
    "tacahua": [
        8663
    ],
    "tacahua mixtec": [
        8663
    ],
    "thawa": [
        8665
    ],
    "tadera-manji": [
        8665
    ],
    "tharawal": [
        8665
    ],
    "thauaira": [
        8665
    ],
    "tawandê": [
        8666
    ],
    "tawaindê": [
        8666
    ],
    "ten kurumba": [
        8675
    ],
    "tatsewalem": [
        8699
    ],
    "tambora": [
        8706
    ],
    "tequenica": [
        8723
    ],
    "tawahka": [
        8732
    ],
    "thin nu wa’ab": [
        8735
    ],
    "tchang": [
        8747
    ],
    "tle": [
        8753
    ],
    "travellers": [
        8770
    ],
    "tarok": [
        8775
    ],
    "taroh": [
        8775
    ],
    "tateburra": [
        8782
    ],
    "terreburra": [
        8782
    ],
    "tandɨ": [
        8784
    ],
    "thrice striped red phula": [
        8792
    ],
    "thrice": [
        8792
    ],
    "tozhuma": [
        8803
    ],
    "tundra yukaghir": [
        8816
    ],
    "tundre": [
        8816
    ],
    "tjeki": [
        8840
    ],
    "tshebu": [
        8840,
        8890
    ],
    "tshibu": [
        8840
    ],
    "tsha phula": [
        8885
    ],
    "tsha": [
        8885
    ],
    "tsapho": [
        8886
    ],
    "tupian": [
        8896
    ],
    "tie yao": [
        8898
    ],
    "tu yao indigenous yao": [
        8898
    ],
    "talu": [
        8914
    ],
    "tagu": [
        8914
    ],
    "taliu": [
        8914
    ],
    "tazhi": [
        8914
    ],
    "tanglang": [
        8915
    ],
    "tholo": [
        8915
    ],
    "thopho": [
        8916
    ],
    "t’aan": [
        8919
    ],
    "tsoyaha": [
        8921
    ],
    "tripolitanian-libyan": [
        8922
    ],
    "tripolitanian judeo-arabic": [
        8922
    ],
    "tripolitanian": [
        8922
    ],
    "tripolita’it": [
        8922
    ],
    "trièu chau": [
        8923,
        8924,
        8925,
        8926
    ],
    "trièu": [
        8923,
        8924,
        8925,
        8926
    ],
    "totsoca": [
        8929
    ],
    "terabul": [
        8956
    ],
    "tor-bul": [
        8956
    ],
    "turibul": [
        8956
    ],
    "turrbal": [
        8956
    ],
    "turrubal": [
        8956
    ],
    "turubul": [
        8956
    ],
    "tshokha": [
        8965
    ],
    "tlacolula": [
        8970,
        8991,
        9125
    ],
    "teococuilco": [
        8973
    ],
    "twar": [
        8978
    ],
    "tabaa": [
        8988
    ],
    "tabaa zapotec": [
        8988
    ],
    "terawan": [
        9002
    ],
    "tamazight, standard moroccan": [
        9014
    ],
    "tayok": [
        9020,
        9021,
        9022,
        9030,
        9040
    ],
    "tuliao": [
        9044,
        9045
    ],
    "tuzu": [
        9044,
        9045
    ],
    "tuyu": [
        9044,
        9045,
        9047,
        9048,
        9181,
        9184,
        9188
    ],
    "tei": [
        9047,
        9048
    ],
    "tei nong": [
        9047,
        9048
    ],
    "tsia": [
        9051
    ],
    "tjevin": [
        9090
    ],
    "tura-ka-molo": [
        9095
    ],
    "tzunitzame": [
        9113,
        9114
    ],
    "tabasco zoque": [
        9117
    ],
    "tehuantepec": [
        9120
    ],
    "totomachapan": [
        9127
    ],
    "totomachapan zapotec": [
        9127
    ],
    "tlacolulita": [
        9130
    ],
    "tlacolulita zapotec": [
        9130
    ],
    "texmelucan": [
        9145
    ],
    "texmelucan zapotec": [
        9145
    ],
    "tiits së": [
        9166
    ],
    "tiits": [
        9166
    ],
    "tilquiapan": [
        9167
    ],
    "tilquiapan zapotec": [
        9167
    ],
    "tejalapan": [
        9168
    ],
    "tejalapan zapotec": [
        9168
    ],
    "tejalápam": [
        9168
    ],
    "tokano": [
        9175
    ],
    "tokama": [
        9175
    ],
    "thó": [
        9181
    ],
    "tianpao": [
        9181
    ],
    "tuhua": [
        9181
    ],
    "toj": [
        9184
    ]
};
